/**
 * @generated SignedSource<<d8edab5100c38d3258b2ce5f330bbf9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "answers"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsCount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsCursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contribuableId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentPageId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "edit"
},
v7 = [
  {
    "kind": "Variable",
    "name": "answers",
    "variableName": "answers"
  },
  {
    "kind": "Variable",
    "name": "contribuableId",
    "variableName": "contribuableId"
  },
  {
    "kind": "Variable",
    "name": "contributionId",
    "variableName": "contributionId"
  },
  {
    "kind": "Variable",
    "name": "currentPageId",
    "variableName": "currentPageId"
  },
  {
    "kind": "Variable",
    "name": "edit",
    "variableName": "edit"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFeatured",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFromAdminUser",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDisplayAuthorized",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesSubmissionAuthorized",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsDisplayAuthorized",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsSubmissionAuthorized",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "themes",
  "plural": true,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionThemesLabel_themes"
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerFormField",
  "kind": "LinkedField",
  "name": "additionalDisplayableFields",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerFormField_field"
    }
  ],
  "storageKey": null
},
v18 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContributionHeader_contribution"
},
v19 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContributionCommentsPanel_contribution"
},
v20 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "VoteButtons_votable"
},
v21 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ReactableMeasures_reactable"
},
v22 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContributionContent_contribution"
},
v23 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "Report_reportable"
},
v24 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContributionBookmarkButton_contribution"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLocation",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserAvatar_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserAuthorName_user"
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v30 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContributionTheme_theme"
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bannerImageUrl",
      "storageKey": null
    }
  ],
  "type": "ContributionsGrid",
  "abstractKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "up",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Votes",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    (v32/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBookmarked",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMine",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reactionsCount",
  "storageKey": null
},
v37 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContributionsDatavizListThemeContribution_contribution"
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    (v40/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": "comments",
  "args": null,
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "__CommentsPanel_comments_connection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Comment_comment"
            },
            (v38/*: any*/)
          ],
          "storageKey": null
        },
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsCount",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionSlug",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "themeId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
},
v49 = [
  (v45/*: any*/),
  (v46/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "ContributionsMapContributionTooltip_contributionMarker"
  }
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alreadySubmitted",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingSeats",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximumSeats",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayMaximumSeats",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayRemainingSeats",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsSubmissionAuthorized",
  "storageKey": null
},
v58 = [
  (v57/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModuleAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFilled",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFillable",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waypointIndex",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextWaypointId",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contrastColor",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchor",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorOffsetX",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorOffsetY",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opacity",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v74 = [
  (v73/*: any*/)
],
v75 = {
  "kind": "InlineFragment",
  "selections": (v74/*: any*/),
  "type": "Image",
  "abstractKey": null
},
v76 = {
  "kind": "InlineFragment",
  "selections": (v74/*: any*/),
  "type": "StaticImage",
  "abstractKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cityWalkWaypointsDefaultZoom",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "CityWalkContribution",
  "kind": "LinkedField",
  "name": "activeContribution",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "didCompleteAllWaypoints",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "CityWalkAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifier",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formHash",
  "storageKey": null
},
v84 = [
  (v8/*: any*/)
],
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toggleAnonymousMode",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disclaimer",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completeMessage",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModuleAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizationsUnauthorizedMessages",
      "kind": "LinkedField",
      "name": "unauthorizedMessages",
      "plural": false,
      "selections": (v58/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsAuthentication",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ValidationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "field",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MutationResult",
  "abstractKey": "__isMutationResult"
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editContribution",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributorContactAuthorized",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresModeration",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitComment",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "ContributionAuthorizationsUnauthorizedMessages",
  "kind": "LinkedField",
  "name": "unauthorizedMessages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributorContact",
      "storageKey": null
    },
    (v8/*: any*/),
    (v94/*: any*/)
  ],
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bookmarksCreationAuthorized",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "themes",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v26/*: any*/),
    (v64/*: any*/),
    (v29/*: any*/),
    (v97/*: any*/)
  ],
  "storageKey": null
},
v99 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isAnswerBase"
},
v100 = [
  (v43/*: any*/)
],
v101 = {
  "kind": "InlineFragment",
  "selections": (v100/*: any*/),
  "type": "AnswerString",
  "abstractKey": null
},
v102 = {
  "kind": "InlineFragment",
  "selections": (v100/*: any*/),
  "type": "AnswerText",
  "abstractKey": null
},
v103 = {
  "kind": "InlineFragment",
  "selections": (v100/*: any*/),
  "type": "AnswerRichText",
  "abstractKey": null
},
v104 = [
  (v8/*: any*/),
  (v26/*: any*/),
  (v73/*: any*/)
],
v105 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": (v104/*: any*/),
      "storageKey": null
    }
  ],
  "type": "AnswerFile",
  "abstractKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedValues",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "other",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherValue",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherFieldLabel",
  "storageKey": null
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    (v106/*: any*/),
    (v107/*: any*/),
    (v108/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v109/*: any*/)
          ],
          "type": "FormFieldCheckBoxes",
          "abstractKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerCheckBoxes",
  "abstractKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerWeightedOption",
  "kind": "LinkedField",
  "name": "dispatchedBudgetValues",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionId",
      "storageKey": null
    },
    (v111/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxBudgetPerOption",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v38/*: any*/),
    (v8/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v115 = {
  "kind": "InlineFragment",
  "selections": [
    (v112/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*: any*/),
            (v114/*: any*/)
          ],
          "type": "FormFieldBudgetDispatcher",
          "abstractKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerBudgetDispatcher",
  "abstractKey": null
},
v116 = {
  "kind": "InlineFragment",
  "selections": [
    (v106/*: any*/)
  ],
  "type": "AnswerSortableList",
  "abstractKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldItem",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": (v84/*: any*/),
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldOptionChoice",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v84/*: any*/),
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldItem",
  "kind": "LinkedField",
  "name": "items",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v119/*: any*/)
  ],
  "storageKey": null
},
v121 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerItemOption",
      "kind": "LinkedField",
      "name": "itemOptions",
      "plural": true,
      "selections": [
        (v117/*: any*/),
        (v118/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v120/*: any*/),
            (v114/*: any*/)
          ],
          "type": "FormFieldMatrix",
          "abstractKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerMatrix",
  "abstractKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedThemeIds",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldThemeOption",
  "kind": "LinkedField",
  "name": "themes",
  "plural": true,
  "selections": [
    (v119/*: any*/),
    (v111/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldThemeOption",
      "kind": "LinkedField",
      "name": "children",
      "plural": true,
      "selections": [
        (v119/*: any*/),
        (v111/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldThemeOption",
          "kind": "LinkedField",
          "name": "children",
          "plural": true,
          "selections": [
            (v119/*: any*/),
            (v111/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldThemeOption",
              "kind": "LinkedField",
              "name": "children",
              "plural": true,
              "selections": [
                (v119/*: any*/),
                (v111/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormFieldThemeOption",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    (v119/*: any*/),
                    (v111/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormFieldThemeOption",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": true,
                      "selections": [
                        (v119/*: any*/),
                        (v111/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormFieldThemeOption",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": true,
                          "selections": [
                            (v119/*: any*/),
                            (v111/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormFieldThemeOption",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                (v119/*: any*/),
                                (v111/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormFieldThemeOption",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    (v119/*: any*/),
                                    (v111/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "FormFieldThemeOption",
                                      "kind": "LinkedField",
                                      "name": "children",
                                      "plural": true,
                                      "selections": [
                                        (v119/*: any*/),
                                        (v111/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "FormFieldThemeOption",
                                          "kind": "LinkedField",
                                          "name": "children",
                                          "plural": true,
                                          "selections": [
                                            (v119/*: any*/),
                                            (v111/*: any*/),
                                            (v8/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v8/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v8/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v8/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v8/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v8/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v8/*: any*/)
                  ],
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v124 = {
  "kind": "InlineFragment",
  "selections": [
    (v122/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v123/*: any*/)
          ],
          "type": "FormFieldThemes",
          "abstractKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerThemes",
  "abstractKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventIds",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": "name",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v127 = {
  "kind": "InlineFragment",
  "selections": [
    (v125/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v126/*: any*/)
          ],
          "type": "FormFieldEvents",
          "abstractKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerEvents",
  "abstractKey": null
},
v128 = {
  "kind": "InlineFragment",
  "selections": (v100/*: any*/),
  "type": "AnswerEmailWithConsents",
  "abstractKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "individualSummary",
  "storageKey": null
},
v130 = {
  "kind": "InlineFragment",
  "selections": [
    (v129/*: any*/)
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "formField",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v119/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v132 = {
  "kind": "InlineFragment",
  "selections": [
    (v131/*: any*/)
  ],
  "type": "AnswerPresentationTitle",
  "abstractKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v135 = [
  (v8/*: any*/),
  (v26/*: any*/)
],
v136 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerFormField",
  "kind": "LinkedField",
  "name": "additionalDisplayableFields",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "answer",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        (v99/*: any*/),
        (v8/*: any*/),
        (v101/*: any*/),
        (v102/*: any*/),
        (v103/*: any*/),
        (v105/*: any*/),
        (v110/*: any*/),
        (v115/*: any*/),
        (v116/*: any*/),
        (v121/*: any*/),
        (v124/*: any*/),
        (v127/*: any*/),
        (v128/*: any*/),
        (v130/*: any*/),
        (v132/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "answers",
              "plural": true,
              "selections": [
                (v38/*: any*/),
                (v8/*: any*/),
                (v99/*: any*/),
                (v101/*: any*/),
                (v102/*: any*/),
                (v103/*: any*/),
                (v105/*: any*/),
                (v110/*: any*/),
                (v115/*: any*/),
                (v116/*: any*/),
                (v121/*: any*/),
                (v124/*: any*/),
                (v127/*: any*/),
                (v128/*: any*/),
                (v130/*: any*/),
                (v132/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "AnswerAddress",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v133/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "formField",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v134/*: any*/)
                  ],
                  "type": "FormFieldBudget",
                  "abstractKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AnswerBudgetChapter",
              "kind": "LinkedField",
              "name": "answers",
              "plural": true,
              "selections": [
                (v8/*: any*/),
                (v133/*: any*/),
                (v131/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AnswerOptionBudgetLine",
                  "kind": "LinkedField",
                  "name": "budgetLines",
                  "plural": true,
                  "selections": [
                    (v111/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stepLabel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormFieldOptionBudgetLine",
                      "kind": "LinkedField",
                      "name": "option",
                      "plural": false,
                      "selections": (v135/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AnswerBudget",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v138 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalViewerFields",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
},
v139 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v8/*: any*/),
    (v138/*: any*/)
  ],
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "concreteType": "IntlMessage",
  "kind": "LinkedField",
  "name": "customIntlMessages",
  "plural": true,
  "selections": [
    (v80/*: any*/),
    (v81/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapseContributionsContent",
  "storageKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionContentCollapsedHeight",
  "storageKey": null
},
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCommentsCount",
  "storageKey": null
},
v144 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "commentsCursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentsCount"
  }
],
v145 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v146 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v26/*: any*/),
    (v8/*: any*/),
    (v138/*: any*/)
  ],
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v93/*: any*/),
    (v94/*: any*/),
    (v14/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v149 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v150 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDownAuthorized",
  "storageKey": null
},
v151 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitVote",
  "storageKey": null
},
v152 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentViewerVote",
  "storageKey": null
},
v153 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleVoteMode",
  "storageKey": null
},
v154 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesMode",
  "storageKey": null
},
v155 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "down",
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingVotesCount",
  "storageKey": null
},
v157 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limitedVotesPerUser",
  "storageKey": null
},
v158 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        (v150/*: any*/),
        (v151/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unauthorizedMessages",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v151/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v152/*: any*/),
    (v153/*: any*/),
    (v154/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v32/*: any*/),
        (v155/*: any*/)
      ],
      "storageKey": null
    },
    (v156/*: any*/),
    (v157/*: any*/)
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v159 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isReportable"
},
v160 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v150/*: any*/)
  ],
  "storageKey": null
},
v161 = {
  "kind": "InlineFragment",
  "selections": [
    (v143/*: any*/),
    (v154/*: any*/),
    (v160/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v32/*: any*/),
        (v155/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v162 = {
  "alias": null,
  "args": (v149/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "CommentsPanel_comments",
  "kind": "LinkedHandle",
  "name": "comments"
},
v163 = {
  "alias": null,
  "args": (v144/*: any*/),
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v10/*: any*/),
            (v43/*: any*/),
            (v145/*: any*/),
            (v146/*: any*/),
            (v11/*: any*/),
            (v147/*: any*/),
            (v148/*: any*/),
            {
              "alias": null,
              "args": (v149/*: any*/),
              "concreteType": "CommentConnection",
              "kind": "LinkedField",
              "name": "comments",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CommentEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Comment",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v8/*: any*/),
                        (v43/*: any*/),
                        (v145/*: any*/),
                        (v146/*: any*/),
                        (v11/*: any*/),
                        (v147/*: any*/),
                        (v148/*: any*/),
                        {
                          "alias": null,
                          "args": (v149/*: any*/),
                          "concreteType": "CommentConnection",
                          "kind": "LinkedField",
                          "name": "comments",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CommentEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Comment",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v8/*: any*/),
                                    (v43/*: any*/),
                                    (v145/*: any*/),
                                    (v146/*: any*/),
                                    (v11/*: any*/),
                                    (v147/*: any*/),
                                    (v148/*: any*/),
                                    {
                                      "alias": null,
                                      "args": (v149/*: any*/),
                                      "concreteType": "CommentConnection",
                                      "kind": "LinkedField",
                                      "name": "comments",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "CommentEdge",
                                          "kind": "LinkedField",
                                          "name": "edges",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "Comment",
                                              "kind": "LinkedField",
                                              "name": "node",
                                              "plural": false,
                                              "selections": [
                                                (v8/*: any*/),
                                                (v43/*: any*/),
                                                (v145/*: any*/),
                                                (v146/*: any*/),
                                                (v11/*: any*/),
                                                (v147/*: any*/),
                                                (v148/*: any*/),
                                                {
                                                  "alias": null,
                                                  "args": (v149/*: any*/),
                                                  "concreteType": "CommentConnection",
                                                  "kind": "LinkedField",
                                                  "name": "comments",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "concreteType": "CommentEdge",
                                                      "kind": "LinkedField",
                                                      "name": "edges",
                                                      "plural": true,
                                                      "selections": [
                                                        {
                                                          "alias": null,
                                                          "args": null,
                                                          "concreteType": "Comment",
                                                          "kind": "LinkedField",
                                                          "name": "node",
                                                          "plural": false,
                                                          "selections": [
                                                            (v8/*: any*/),
                                                            (v43/*: any*/),
                                                            (v145/*: any*/),
                                                            (v146/*: any*/),
                                                            (v11/*: any*/),
                                                            (v147/*: any*/),
                                                            (v148/*: any*/),
                                                            {
                                                              "alias": null,
                                                              "args": (v149/*: any*/),
                                                              "concreteType": "CommentConnection",
                                                              "kind": "LinkedField",
                                                              "name": "comments",
                                                              "plural": false,
                                                              "selections": [
                                                                {
                                                                  "alias": null,
                                                                  "args": null,
                                                                  "concreteType": "CommentEdge",
                                                                  "kind": "LinkedField",
                                                                  "name": "edges",
                                                                  "plural": true,
                                                                  "selections": [
                                                                    {
                                                                      "alias": null,
                                                                      "args": null,
                                                                      "concreteType": "Comment",
                                                                      "kind": "LinkedField",
                                                                      "name": "node",
                                                                      "plural": false,
                                                                      "selections": [
                                                                        (v8/*: any*/),
                                                                        (v43/*: any*/),
                                                                        (v145/*: any*/),
                                                                        (v146/*: any*/),
                                                                        (v11/*: any*/),
                                                                        (v147/*: any*/),
                                                                        (v148/*: any*/),
                                                                        {
                                                                          "alias": null,
                                                                          "args": (v149/*: any*/),
                                                                          "concreteType": "CommentConnection",
                                                                          "kind": "LinkedField",
                                                                          "name": "comments",
                                                                          "plural": false,
                                                                          "selections": [
                                                                            {
                                                                              "alias": null,
                                                                              "args": null,
                                                                              "concreteType": "CommentEdge",
                                                                              "kind": "LinkedField",
                                                                              "name": "edges",
                                                                              "plural": true,
                                                                              "selections": [
                                                                                {
                                                                                  "alias": null,
                                                                                  "args": null,
                                                                                  "concreteType": "Comment",
                                                                                  "kind": "LinkedField",
                                                                                  "name": "node",
                                                                                  "plural": false,
                                                                                  "selections": [
                                                                                    (v8/*: any*/),
                                                                                    (v43/*: any*/),
                                                                                    (v145/*: any*/),
                                                                                    (v146/*: any*/),
                                                                                    (v11/*: any*/),
                                                                                    (v147/*: any*/),
                                                                                    (v148/*: any*/),
                                                                                    {
                                                                                      "alias": null,
                                                                                      "args": (v149/*: any*/),
                                                                                      "concreteType": "CommentConnection",
                                                                                      "kind": "LinkedField",
                                                                                      "name": "comments",
                                                                                      "plural": false,
                                                                                      "selections": [
                                                                                        {
                                                                                          "alias": null,
                                                                                          "args": null,
                                                                                          "concreteType": "CommentEdge",
                                                                                          "kind": "LinkedField",
                                                                                          "name": "edges",
                                                                                          "plural": true,
                                                                                          "selections": [
                                                                                            {
                                                                                              "alias": null,
                                                                                              "args": null,
                                                                                              "concreteType": "Comment",
                                                                                              "kind": "LinkedField",
                                                                                              "name": "node",
                                                                                              "plural": false,
                                                                                              "selections": [
                                                                                                (v8/*: any*/),
                                                                                                (v43/*: any*/),
                                                                                                (v145/*: any*/),
                                                                                                (v146/*: any*/),
                                                                                                (v11/*: any*/),
                                                                                                (v147/*: any*/),
                                                                                                (v148/*: any*/),
                                                                                                {
                                                                                                  "alias": null,
                                                                                                  "args": (v149/*: any*/),
                                                                                                  "concreteType": "CommentConnection",
                                                                                                  "kind": "LinkedField",
                                                                                                  "name": "comments",
                                                                                                  "plural": false,
                                                                                                  "selections": [
                                                                                                    {
                                                                                                      "alias": null,
                                                                                                      "args": null,
                                                                                                      "concreteType": "CommentEdge",
                                                                                                      "kind": "LinkedField",
                                                                                                      "name": "edges",
                                                                                                      "plural": true,
                                                                                                      "selections": [
                                                                                                        {
                                                                                                          "alias": null,
                                                                                                          "args": null,
                                                                                                          "concreteType": "Comment",
                                                                                                          "kind": "LinkedField",
                                                                                                          "name": "node",
                                                                                                          "plural": false,
                                                                                                          "selections": [
                                                                                                            (v8/*: any*/),
                                                                                                            (v43/*: any*/),
                                                                                                            (v145/*: any*/),
                                                                                                            (v146/*: any*/),
                                                                                                            (v11/*: any*/),
                                                                                                            (v147/*: any*/),
                                                                                                            (v148/*: any*/),
                                                                                                            {
                                                                                                              "alias": null,
                                                                                                              "args": (v149/*: any*/),
                                                                                                              "concreteType": "CommentConnection",
                                                                                                              "kind": "LinkedField",
                                                                                                              "name": "comments",
                                                                                                              "plural": false,
                                                                                                              "selections": [
                                                                                                                {
                                                                                                                  "alias": null,
                                                                                                                  "args": null,
                                                                                                                  "concreteType": "CommentEdge",
                                                                                                                  "kind": "LinkedField",
                                                                                                                  "name": "edges",
                                                                                                                  "plural": true,
                                                                                                                  "selections": [
                                                                                                                    {
                                                                                                                      "alias": null,
                                                                                                                      "args": null,
                                                                                                                      "concreteType": "Comment",
                                                                                                                      "kind": "LinkedField",
                                                                                                                      "name": "node",
                                                                                                                      "plural": false,
                                                                                                                      "selections": [
                                                                                                                        (v8/*: any*/),
                                                                                                                        (v43/*: any*/),
                                                                                                                        (v145/*: any*/),
                                                                                                                        (v146/*: any*/),
                                                                                                                        (v11/*: any*/),
                                                                                                                        (v147/*: any*/),
                                                                                                                        (v148/*: any*/),
                                                                                                                        (v38/*: any*/),
                                                                                                                        (v158/*: any*/),
                                                                                                                        (v159/*: any*/),
                                                                                                                        (v161/*: any*/)
                                                                                                                      ],
                                                                                                                      "storageKey": null
                                                                                                                    },
                                                                                                                    (v39/*: any*/)
                                                                                                                  ],
                                                                                                                  "storageKey": null
                                                                                                                },
                                                                                                                (v41/*: any*/)
                                                                                                              ],
                                                                                                              "storageKey": "comments(first:2147483647)"
                                                                                                            },
                                                                                                            (v162/*: any*/),
                                                                                                            (v38/*: any*/),
                                                                                                            (v158/*: any*/),
                                                                                                            (v159/*: any*/),
                                                                                                            (v161/*: any*/)
                                                                                                          ],
                                                                                                          "storageKey": null
                                                                                                        },
                                                                                                        (v39/*: any*/)
                                                                                                      ],
                                                                                                      "storageKey": null
                                                                                                    },
                                                                                                    (v41/*: any*/)
                                                                                                  ],
                                                                                                  "storageKey": "comments(first:2147483647)"
                                                                                                },
                                                                                                (v162/*: any*/),
                                                                                                (v38/*: any*/),
                                                                                                (v158/*: any*/),
                                                                                                (v159/*: any*/),
                                                                                                (v161/*: any*/)
                                                                                              ],
                                                                                              "storageKey": null
                                                                                            },
                                                                                            (v39/*: any*/)
                                                                                          ],
                                                                                          "storageKey": null
                                                                                        },
                                                                                        (v41/*: any*/)
                                                                                      ],
                                                                                      "storageKey": "comments(first:2147483647)"
                                                                                    },
                                                                                    (v162/*: any*/),
                                                                                    (v38/*: any*/),
                                                                                    (v158/*: any*/),
                                                                                    (v159/*: any*/),
                                                                                    (v161/*: any*/)
                                                                                  ],
                                                                                  "storageKey": null
                                                                                },
                                                                                (v39/*: any*/)
                                                                              ],
                                                                              "storageKey": null
                                                                            },
                                                                            (v41/*: any*/)
                                                                          ],
                                                                          "storageKey": "comments(first:2147483647)"
                                                                        },
                                                                        (v162/*: any*/),
                                                                        (v38/*: any*/),
                                                                        (v158/*: any*/),
                                                                        (v159/*: any*/),
                                                                        (v161/*: any*/)
                                                                      ],
                                                                      "storageKey": null
                                                                    },
                                                                    (v39/*: any*/)
                                                                  ],
                                                                  "storageKey": null
                                                                },
                                                                (v41/*: any*/)
                                                              ],
                                                              "storageKey": "comments(first:2147483647)"
                                                            },
                                                            (v162/*: any*/),
                                                            (v38/*: any*/),
                                                            (v158/*: any*/),
                                                            (v159/*: any*/),
                                                            (v161/*: any*/)
                                                          ],
                                                          "storageKey": null
                                                        },
                                                        (v39/*: any*/)
                                                      ],
                                                      "storageKey": null
                                                    },
                                                    (v41/*: any*/)
                                                  ],
                                                  "storageKey": "comments(first:2147483647)"
                                                },
                                                (v162/*: any*/),
                                                (v38/*: any*/),
                                                (v158/*: any*/),
                                                (v159/*: any*/),
                                                (v161/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            (v39/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v41/*: any*/)
                                      ],
                                      "storageKey": "comments(first:2147483647)"
                                    },
                                    (v162/*: any*/),
                                    (v38/*: any*/),
                                    (v158/*: any*/),
                                    (v159/*: any*/),
                                    (v161/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v39/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v41/*: any*/)
                          ],
                          "storageKey": "comments(first:2147483647)"
                        },
                        (v162/*: any*/),
                        (v38/*: any*/),
                        (v158/*: any*/),
                        (v159/*: any*/),
                        (v161/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v39/*: any*/)
                  ],
                  "storageKey": null
                },
                (v41/*: any*/)
              ],
              "storageKey": "comments(first:2147483647)"
            },
            (v162/*: any*/),
            (v38/*: any*/),
            (v158/*: any*/),
            (v159/*: any*/),
            (v161/*: any*/)
          ],
          "storageKey": null
        },
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "storageKey": null
},
v164 = {
  "alias": null,
  "args": (v144/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "CommentsPanel_comments",
  "kind": "LinkedHandle",
  "name": "comments"
},
v165 = {
  "alias": null,
  "args": null,
  "concreteType": "ThemeImages",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preview",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v166 = {
  "alias": null,
  "args": null,
  "concreteType": "Votes",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v167 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v168 = {
  "alias": null,
  "args": null,
  "concreteType": "Votes",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    (v155/*: any*/)
  ],
  "storageKey": null
},
v169 = {
  "kind": "InlineFragment",
  "selections": [
    (v154/*: any*/),
    (v160/*: any*/),
    (v168/*: any*/)
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v170 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        (v150/*: any*/),
        (v151/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unauthorizedMessages",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v151/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v152/*: any*/),
    (v153/*: any*/),
    (v154/*: any*/),
    (v168/*: any*/),
    (v156/*: any*/),
    (v157/*: any*/)
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v171 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v64/*: any*/),
      (v65/*: any*/),
      (v66/*: any*/),
      (v67/*: any*/),
      (v68/*: any*/),
      (v69/*: any*/),
      (v70/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v38/*: any*/),
          (v75/*: any*/),
          (v76/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  },
  (v8/*: any*/)
],
v172 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementThemeStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v171/*: any*/),
  "storageKey": null
},
v173 = [
  (v45/*: any*/),
  (v46/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/),
  (v8/*: any*/)
],
v174 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomDefault",
  "storageKey": null
},
v175 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomMin",
  "storageKey": null
},
v176 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomMax",
  "storageKey": null
},
v177 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileZoomDefault",
  "storageKey": null
},
v178 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileZoomMin",
  "storageKey": null
},
v179 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileZoomMax",
  "storageKey": null
},
v180 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "centerLatitude",
  "storageKey": null
},
v181 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "centerLongitude",
  "storageKey": null
},
v182 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tileLayerUrl",
  "storageKey": null
},
v183 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapDataAttribution",
  "storageKey": null
},
v184 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMin",
  "storageKey": null
},
v185 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMax",
  "storageKey": null
},
v186 = {
  "alias": null,
  "args": null,
  "concreteType": "MapZoomLevelConfiguration",
  "kind": "LinkedField",
  "name": "zoomLevels",
  "plural": true,
  "selections": [
    (v184/*: any*/),
    (v185/*: any*/),
    (v182/*: any*/),
    (v183/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v187 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasElements",
  "storageKey": null
},
v188 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vectorTileUrl",
  "storageKey": null
},
v189 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markersMaxClusterRadius",
  "storageKey": null
},
v190 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zIndexOffset",
  "storageKey": null
},
v191 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v171/*: any*/),
  "storageKey": null
},
v192 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementBackgroundStyle",
  "kind": "LinkedField",
  "name": "backgroundStyle",
  "plural": false,
  "selections": (v171/*: any*/),
  "storageKey": null
},
v193 = [
  (v191/*: any*/),
  (v192/*: any*/)
],
v194 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPointStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": [
    (v190/*: any*/),
    (v191/*: any*/),
    (v192/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementZoomLevelStyle",
      "kind": "LinkedField",
      "name": "zoomLevels",
      "plural": true,
      "selections": [
        (v184/*: any*/),
        (v185/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v193/*: any*/),
              "type": "MapElementPointStyle",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v193/*: any*/),
              "type": "MapElementCompoundFeatureStyle",
              "abstractKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v195 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPoint",
  "kind": "LinkedField",
  "name": "clusterizedPoints",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInformationWindow",
      "storageKey": null
    },
    (v47/*: any*/),
    (v48/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mapElementGeometryId",
      "storageKey": null
    },
    (v194/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementTooltip",
      "kind": "LinkedField",
      "name": "tooltip",
      "plural": false,
      "selections": [
        (v43/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v196 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterElementsOutOnInitialize",
  "storageKey": null
},
v197 = [
  (v38/*: any*/),
  (v8/*: any*/)
],
v198 = {
  "alias": null,
  "args": null,
  "concreteType": "MapFilterList",
  "kind": "LinkedField",
  "name": "filterLists",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v196/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MapTaxonomy",
              "kind": "LinkedField",
              "name": "mapTaxonomies",
              "plural": true,
              "selections": [
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MapTaxonomy",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": (v84/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "MapFilterTaxonomy",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v196/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "mapElements",
              "plural": true,
              "selections": (v197/*: any*/),
              "storageKey": null
            }
          ],
          "type": "MapFilterElement",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v199 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v200 = [
  (v65/*: any*/),
  (v72/*: any*/),
  (v199/*: any*/),
  (v67/*: any*/),
  (v190/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MapElementZoomLevelStyle",
    "kind": "LinkedField",
    "name": "zoomLevels",
    "plural": true,
    "selections": [
      (v184/*: any*/),
      (v185/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "style",
        "plural": false,
        "selections": [
          (v38/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v65/*: any*/),
              (v72/*: any*/),
              (v199/*: any*/),
              (v67/*: any*/),
              (v190/*: any*/)
            ],
            "type": "MapElementPathStyle",
            "abstractKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  (v8/*: any*/)
],
v201 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPathStyle",
  "kind": "LinkedField",
  "name": "borderStyle",
  "plural": false,
  "selections": (v200/*: any*/),
  "storageKey": null
},
v202 = {
  "alias": null,
  "args": (v149/*: any*/),
  "concreteType": "MapElementConnection",
  "kind": "LinkedField",
  "name": "elements",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MapTaxonomy",
              "kind": "LinkedField",
              "name": "mapTaxonomies",
              "plural": true,
              "selections": (v84/*: any*/),
              "storageKey": null
            },
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isMapElement"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "geometriesType",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MapElementCompoundFeatureStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": [
                    (v190/*: any*/),
                    (v191/*: any*/),
                    (v201/*: any*/),
                    (v192/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MapElementShadowStyle",
                      "kind": "LinkedField",
                      "name": "shadowStyle",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "offsetX",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "offsetY",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "blur",
                          "storageKey": null
                        },
                        (v65/*: any*/),
                        (v72/*: any*/),
                        (v8/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MapElementZoomLevelStyle",
                      "kind": "LinkedField",
                      "name": "zoomLevels",
                      "plural": true,
                      "selections": [
                        (v184/*: any*/),
                        (v185/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "style",
                          "plural": false,
                          "selections": [
                            (v38/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v191/*: any*/)
                              ],
                              "type": "MapElementCompoundFeatureStyle",
                              "abstractKey": null
                            },
                            (v8/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v8/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v8/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "MapElementCompoundFeature",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MapElementPathStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": (v200/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "MapElementPath",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v194/*: any*/)
              ],
              "type": "MapElementPoint",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MapElementShapeStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": [
                    (v190/*: any*/),
                    (v201/*: any*/),
                    (v192/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MapElementZoomLevelStyle",
                      "kind": "LinkedField",
                      "name": "zoomLevels",
                      "plural": true,
                      "selections": [
                        (v184/*: any*/),
                        (v185/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "style",
                          "plural": false,
                          "selections": [
                            (v38/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v201/*: any*/),
                                (v192/*: any*/)
                              ],
                              "type": "MapElementShapeStyle",
                              "abstractKey": null
                            },
                            (v8/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v8/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v8/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "MapElementShape",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "storageKey": "elements(first:2147483647)"
},
v203 = {
  "alias": null,
  "args": (v149/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "MapElements_elements",
  "kind": "LinkedHandle",
  "name": "elements"
},
v204 = {
  "kind": "InlineFragment",
  "selections": [
    (v174/*: any*/),
    (v175/*: any*/),
    (v176/*: any*/),
    (v177/*: any*/),
    (v178/*: any*/),
    (v179/*: any*/),
    (v180/*: any*/),
    (v181/*: any*/),
    (v182/*: any*/),
    (v183/*: any*/),
    (v186/*: any*/),
    (v187/*: any*/),
    (v188/*: any*/),
    (v189/*: any*/),
    (v195/*: any*/),
    (v198/*: any*/),
    (v202/*: any*/),
    (v203/*: any*/)
  ],
  "type": "Map",
  "abstractKey": "__isMap"
},
v205 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domId",
  "storageKey": null
},
v206 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPageSectionBase"
},
v207 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsible",
  "storageKey": null
},
v208 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsedHeight",
  "storageKey": null
},
v209 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsRatio",
  "storageKey": null
},
v210 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsOrder",
  "storageKey": null
},
v211 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullHeight",
  "storageKey": null
},
v212 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v64/*: any*/)
  ],
  "type": "PageSectionWithHeadingData",
  "abstractKey": "__isPageSectionWithHeadingData"
},
v213 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    (v212/*: any*/)
  ],
  "type": "PageSectionSidebarText",
  "abstractKey": null
},
v214 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    (v64/*: any*/),
    (v73/*: any*/)
  ],
  "type": "PageSectionSidebarLinkBlock",
  "abstractKey": null
},
v215 = {
  "kind": "InlineFragment",
  "selections": [
    (v64/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removeRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UsersGroup",
      "kind": "LinkedField",
      "name": "usersGroup",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyGroupMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyRequested",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UsersGroupAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendJoinGroupRequest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionSidebarUsersGroupRequestLinkBlock",
  "abstractKey": null
},
v216 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v217 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v218 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hlsUrl",
  "storageKey": null
},
v219 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v220 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaTitle",
  "storageKey": null
},
v221 = [
  (v73/*: any*/),
  (v8/*: any*/)
],
v222 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "transcription",
  "plural": false,
  "selections": (v221/*: any*/),
  "storageKey": null
},
v223 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "audio",
  "plural": false,
  "selections": (v221/*: any*/),
  "storageKey": null
},
v224 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "altText",
  "storageKey": null
},
v225 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x15Url",
  "storageKey": null
},
v226 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x2Url",
  "storageKey": null
},
v227 = [
  (v73/*: any*/),
  (v225/*: any*/),
  (v226/*: any*/),
  (v67/*: any*/),
  (v68/*: any*/)
],
v228 = [
  (v224/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "large",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ratio",
        "storageKey": null
      },
      (v73/*: any*/),
      (v225/*: any*/),
      (v226/*: any*/),
      (v67/*: any*/),
      (v68/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "medium",
    "plural": false,
    "selections": (v227/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "small",
    "plural": false,
    "selections": (v227/*: any*/),
    "storageKey": null
  },
  (v8/*: any*/)
],
v229 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hlsLibUrl",
      "storageKey": null
    },
    (v67/*: any*/),
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": (v228/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WithBunnyStreamVideo",
  "abstractKey": "__isWithBunnyStreamVideo"
},
v230 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoplay",
  "storageKey": null
},
v231 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slidesInterval",
  "storageKey": null
},
v232 = {
  "alias": null,
  "args": null,
  "concreteType": "Slide",
  "kind": "LinkedField",
  "name": "slides",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v73/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableOverlay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayOpacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v228/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v233 = {
  "alias": null,
  "args": null,
  "concreteType": "LibraryFile",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v26/*: any*/),
    (v73/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileExtension",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v234 = {
  "alias": null,
  "args": null,
  "concreteType": "ResourceTarget",
  "kind": "LinkedField",
  "name": "resourceTargets",
  "plural": true,
  "selections": (v104/*: any*/),
  "storageKey": null
},
v235 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v216/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "analyticsData",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v8/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isAnalyticsDatumInterface"
        },
        (v119/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionAnalyticsDataList",
  "abstractKey": null
},
v236 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v28/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "visualization",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v50/*: any*/)
              ],
              "type": "EventVisualization",
              "abstractKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v10/*: any*/),
    (v194/*: any*/)
  ],
  "type": "PageSectionSidebarEventsList",
  "abstractKey": null
},
v237 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayQuestionsLabel",
  "storageKey": null
},
v238 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayParticipationData",
  "storageKey": null
},
v239 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "results",
  "plural": true,
  "selections": (v197/*: any*/),
  "storageKey": null
},
v240 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "participativeModuleIds",
  "storageKey": null
},
v241 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v242 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModule",
  "kind": "LinkedField",
  "name": "participativeModules",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v28/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        (v64/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Step",
      "kind": "LinkedField",
      "name": "currentStep",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        (v241/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v150/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsCountDisplayAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesUpCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesDownCount",
      "storageKey": null
    },
    (v44/*: any*/)
  ],
  "storageKey": null
},
v243 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarResource",
  "kind": "LinkedField",
  "name": "resources",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v65/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/),
    (v10/*: any*/),
    (v73/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventMode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v244 = {
  "alias": null,
  "args": (v149/*: any*/),
  "concreteType": "PageSectionBaseConnection",
  "kind": "LinkedField",
  "name": "sections",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageSectionBaseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v8/*: any*/),
            (v205/*: any*/),
            (v211/*: any*/),
            (v206/*: any*/),
            (v213/*: any*/),
            (v214/*: any*/),
            (v215/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v10/*: any*/),
                (v64/*: any*/),
                (v216/*: any*/),
                (v217/*: any*/),
                (v73/*: any*/),
                (v218/*: any*/),
                (v219/*: any*/),
                (v220/*: any*/),
                (v222/*: any*/),
                (v223/*: any*/),
                (v229/*: any*/)
              ],
              "type": "PageSectionEmbed",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v230/*: any*/),
                (v231/*: any*/),
                (v232/*: any*/),
                (v212/*: any*/)
              ],
              "type": "PageSectionSidebarBanner",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v233/*: any*/),
                (v212/*: any*/)
              ],
              "type": "PageSectionFilesList",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v234/*: any*/),
                (v212/*: any*/)
              ],
              "type": "PageSectionPagesList",
              "abstractKey": null
            },
            (v235/*: any*/),
            (v236/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v10/*: any*/),
                (v216/*: any*/),
                (v64/*: any*/),
                (v237/*: any*/),
                (v238/*: any*/),
                (v239/*: any*/),
                (v240/*: any*/)
              ],
              "type": "PageSectionParticipativeModuleResults",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v242/*: any*/),
                (v212/*: any*/)
              ],
              "type": "PageSectionParticipativeModulesList",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v10/*: any*/),
                (v216/*: any*/),
                (v243/*: any*/)
              ],
              "type": "PageSectionCalendar",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "storageKey": "sections(first:2147483647)"
},
v245 = {
  "alias": null,
  "args": (v149/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "Sidebar_sections",
  "kind": "LinkedHandle",
  "name": "sections"
},
v246 = {
  "alias": null,
  "args": null,
  "concreteType": "Sidebar",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSections",
      "storageKey": null
    },
    (v244/*: any*/),
    (v245/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v247 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayMode",
  "storageKey": null
},
v248 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isMap"
},
v249 = [
  (v10/*: any*/),
  (v64/*: any*/),
  (v216/*: any*/)
],
v250 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v251 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v252 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "values",
  "storageKey": null
},
v253 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "formField",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v251/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v254 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v255 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hintPosition",
  "storageKey": null
},
v256 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hide",
  "storageKey": null
},
v257 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnly",
  "storageKey": null
},
v258 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoComplete",
    "storageKey": null
  }
],
v259 = {
  "kind": "InlineFragment",
  "selections": (v258/*: any*/),
  "type": "FormFieldString",
  "abstractKey": null
},
v260 = {
  "kind": "InlineFragment",
  "selections": (v258/*: any*/),
  "type": "FormFieldText",
  "abstractKey": null
},
v261 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentAttachmentToken",
  "storageKey": null
},
v262 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displaySimilarContributionsSuggestions",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v263 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourcesAttachmentToken",
  "storageKey": null
},
v264 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "sources",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v26/*: any*/),
    (v73/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v265 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "multiple",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxFiles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedFileExtensions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maximumFileSize",
      "storageKey": null
    }
  ],
  "type": "FormFieldFile",
  "abstractKey": null
},
v266 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOtherField",
  "storageKey": null
},
v267 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleOptionSelection",
  "storageKey": null
},
v268 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximumSelectableOptions",
  "storageKey": null
},
v269 = {
  "kind": "InlineFragment",
  "selections": [
    (v266/*: any*/),
    (v109/*: any*/),
    (v267/*: any*/),
    (v268/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectableType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldOptionChoice",
      "kind": "LinkedField",
      "name": "listedOptions",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCorrect",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correctionText",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionsSearchable",
      "storageKey": null
    }
  ],
  "type": "FormFieldCheckBoxes",
  "abstractKey": null
},
v270 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldOptionChoice",
  "kind": "LinkedField",
  "name": "selectedOptions",
  "plural": true,
  "selections": (v135/*: any*/),
  "storageKey": null
},
v271 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget",
      "storageKey": null
    },
    (v113/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minBudgetToSpend",
      "storageKey": null
    },
    (v114/*: any*/)
  ],
  "type": "FormFieldBudgetDispatcher",
  "abstractKey": null
},
v272 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maximumThemes",
      "storageKey": null
    },
    (v123/*: any*/)
  ],
  "type": "FormFieldThemes",
  "abstractKey": null
},
v273 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "none",
  "storageKey": null
},
v274 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maximumEvents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowNone",
      "storageKey": null
    },
    (v126/*: any*/)
  ],
  "type": "FormFieldEvents",
  "abstractKey": null
},
v275 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "consentGiven",
  "storageKey": null
},
v276 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayEmailConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consentLabel",
      "storageKey": null
    }
  ],
  "type": "FormFieldEmailWithConsents",
  "abstractKey": null
},
v277 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v278 = {
  "alias": null,
  "args": null,
  "concreteType": "OralInterviewMessage",
  "kind": "LinkedField",
  "name": "messages",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v279 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closingMessage",
      "storageKey": null
    }
  ],
  "type": "FormFieldOralInterview",
  "abstractKey": null
},
v280 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimumSelectableOptions",
      "storageKey": null
    },
    (v268/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v8/*: any*/),
        (v26/*: any*/),
        (v216/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "FormFieldSortableList",
  "abstractKey": null
},
v281 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerItemOption",
  "kind": "LinkedField",
  "name": "itemOptions",
  "plural": true,
  "selections": [
    (v107/*: any*/),
    (v117/*: any*/),
    (v118/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v282 = {
  "kind": "InlineFragment",
  "selections": [
    (v268/*: any*/),
    (v267/*: any*/),
    (v266/*: any*/),
    (v109/*: any*/),
    (v120/*: any*/),
    (v114/*: any*/)
  ],
  "type": "FormFieldMatrix",
  "abstractKey": null
},
v283 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v119/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTitle",
  "abstractKey": null
},
v284 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v100/*: any*/),
          "type": "FormFieldPresentationTextZone",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTextZone",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateContributionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "ValidateContributionPayload",
        "kind": "LinkedField",
        "name": "validateContribution",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContributionEdge",
            "kind": "LinkedField",
            "name": "newContributionEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contribution",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionAuthorizations",
                    "kind": "LinkedField",
                    "name": "authorizations",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipativeModule",
                    "kind": "LinkedField",
                    "name": "participativeModule",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "visualization",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contribution",
            "kind": "LinkedField",
            "name": "contribution",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v10/*: any*/),
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionMarker",
                "kind": "LinkedField",
                "name": "marker",
                "plural": false,
                "selections": (v49/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contribuable",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "visualization",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v50/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventAuthorizations",
                                "kind": "LinkedField",
                                "name": "authorizations",
                                "plural": false,
                                "selections": [
                                  (v55/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "EventMap_event"
                              }
                            ],
                            "type": "EventVisualization",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v59/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TitleBarWithAction_resource"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SubscribeToEventButton_participativeModule"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventCalendarDropdownButton_participativeModule"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PageSections_page"
                      }
                    ],
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sidebar",
                        "kind": "LinkedField",
                        "name": "sidebar",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Sidebar_sidebar"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v47/*: any*/),
                              (v48/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MapElementPointStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapElementIconStyle",
                                    "kind": "LinkedField",
                                    "name": "iconStyle",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v64/*: any*/),
                                          (v65/*: any*/),
                                          (v66/*: any*/),
                                          (v67/*: any*/),
                                          (v68/*: any*/),
                                          (v69/*: any*/),
                                          (v70/*: any*/),
                                          (v71/*: any*/),
                                          (v72/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "image",
                                            "plural": false,
                                            "selections": [
                                              (v75/*: any*/),
                                              (v76/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "MapElementImageStyle",
                                        "abstractKey": "__isMapElementImageStyle"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MapElementPoint",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CityWalk",
                        "kind": "LinkedField",
                        "name": "cityWalk",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CityWalkWaypoint",
                            "kind": "LinkedField",
                            "name": "waypoints",
                            "plural": true,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "CityWalkTimeline_waypoints"
                              }
                            ],
                            "storageKey": null
                          },
                          (v78/*: any*/),
                          (v79/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IntlMessage",
                            "kind": "LinkedField",
                            "name": "customIntlMessages",
                            "plural": true,
                            "selections": [
                              (v80/*: any*/),
                              (v81/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "MapContextProvider_map"
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "CityWalkLayout_cityWalk"
                                  }
                                ],
                                "type": "CityWalk",
                                "abstractKey": null
                              }
                            ],
                            "type": "ParticipativeModuleVisualization",
                            "abstractKey": "__isParticipativeModuleVisualization"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CityWalkWaypoint",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v82/*: any*/),
              (v83/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentPage",
                "plural": false,
                "selections": (v84/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  (v85/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModule",
                "kind": "LinkedField",
                "name": "participativeModule",
                "plural": false,
                "selections": [
                  (v86/*: any*/),
                  (v87/*: any*/),
                  (v88/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visualization",
                    "plural": false,
                    "selections": [
                      (v89/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v11/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v25/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v42/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormDisclaimer_contribution"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormPage_contribution"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormComplete_contribution"
              },
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v37/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContributionMarkerEdge",
            "kind": "LinkedField",
            "name": "newContributionMarkerEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionMarker",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v49/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v90/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "ValidateContributionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "ValidateContributionPayload",
        "kind": "LinkedField",
        "name": "validateContribution",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContributionEdge",
            "kind": "LinkedField",
            "name": "newContributionEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contribution",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionAuthorizations",
                    "kind": "LinkedField",
                    "name": "authorizations",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v8/*: any*/),
                      (v91/*: any*/),
                      (v92/*: any*/),
                      (v93/*: any*/),
                      (v95/*: any*/),
                      (v94/*: any*/),
                      (v96/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v98/*: any*/),
                  (v136/*: any*/),
                  (v137/*: any*/),
                  (v28/*: any*/),
                  (v139/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipativeModule",
                    "kind": "LinkedField",
                    "name": "participativeModule",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "visualization",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v140/*: any*/),
                          (v8/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v141/*: any*/),
                      (v142/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v143/*: any*/),
                  (v163/*: any*/),
                  (v164/*: any*/),
                  (v43/*: any*/),
                  (v34/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v26/*: any*/),
                      (v97/*: any*/),
                      (v165/*: any*/),
                      (v8/*: any*/),
                      (v64/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v64/*: any*/),
                          (v29/*: any*/),
                          (v97/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": [
                              (v64/*: any*/),
                              (v29/*: any*/),
                              (v97/*: any*/),
                              (v26/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v166/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v167/*: any*/),
                  (v169/*: any*/),
                  (v170/*: any*/),
                  (v159/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contribution",
            "kind": "LinkedField",
            "name": "contribution",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v10/*: any*/),
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v44/*: any*/),
                          (v64/*: any*/),
                          (v29/*: any*/),
                          (v97/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v64/*: any*/),
                      (v29/*: any*/),
                      (v97/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v172/*: any*/),
                  (v29/*: any*/),
                  (v26/*: any*/),
                  (v97/*: any*/),
                  (v165/*: any*/),
                  (v64/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionMarker",
                "kind": "LinkedField",
                "name": "marker",
                "plural": false,
                "selections": (v173/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contribuable",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "visualization",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v8/*: any*/),
                          (v140/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v50/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventAuthorizations",
                                "kind": "LinkedField",
                                "name": "authorizations",
                                "plural": false,
                                "selections": [
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "allowAddingEventsToCalendar",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v47/*: any*/),
                              (v48/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventMarker",
                                "kind": "LinkedField",
                                "name": "marker",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "targetUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "tooltipContent",
                                        "storageKey": null
                                      },
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapMarkerStyle",
                                        "kind": "LinkedField",
                                        "name": "markerStyle",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "backgroundColor",
                                            "storageKey": null
                                          },
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MapMarker",
                                    "abstractKey": "__isMapMarker"
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VisualizationMap",
                                "kind": "LinkedField",
                                "name": "map",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v204/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullAddress",
                                "storageKey": null
                              }
                            ],
                            "type": "EventVisualization",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v59/*: any*/),
                      (v28/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                              (v38/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "resourcePath",
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ResourceTreeTaxonomy",
                            "kind": "LinkedField",
                            "name": "taxonomies",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Taxonomy",
                                "kind": "LinkedField",
                                "name": "taxonomy",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "titleImageUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "allowSendingNotificationOnContentUpdate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "alreadySubscribed",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subscribersCount",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ResourceTreeLeaf",
                                "abstractKey": "__isResourceTreeLeaf"
                              }
                            ],
                            "type": "ResourceWithSubscription",
                            "abstractKey": "__isResourceWithSubscription"
                          }
                        ],
                        "type": "ResourceTreeLeaf",
                        "abstractKey": "__isResourceTreeLeaf"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": (v149/*: any*/),
                            "concreteType": "PageSectionBaseConnection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageSectionBaseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v8/*: any*/),
                                      (v205/*: any*/),
                                      (v206/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v43/*: any*/),
                                          (v207/*: any*/),
                                          (v208/*: any*/),
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/)
                                        ],
                                        "type": "PageSectionText",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v230/*: any*/),
                                          (v231/*: any*/),
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/),
                                          (v232/*: any*/)
                                        ],
                                        "type": "PageSectionBanner",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v216/*: any*/),
                                          (v64/*: any*/),
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/),
                                          (v242/*: any*/)
                                        ],
                                        "type": "PageSectionParticipativeModulesList",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v216/*: any*/),
                                          (v247/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hideIfEmpty",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "kind": "LinkedField",
                                            "name": "events",
                                            "plural": true,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v28/*: any*/),
                                              (v10/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "visualization",
                                                "plural": false,
                                                "selections": [
                                                  (v38/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v50/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "placeName",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "address",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "zip",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "city",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "EventVisualization",
                                                    "abstractKey": null
                                                  },
                                                  (v8/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PageSectionEventsList",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/),
                                          (v243/*: any*/)
                                        ],
                                        "type": "PageSectionCalendar",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "actorsPerRow",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "contentAlignment",
                                            "storageKey": null
                                          },
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Actor",
                                            "kind": "LinkedField",
                                            "name": "actors",
                                            "plural": true,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v26/*: any*/),
                                              (v216/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ResponsiveImage",
                                                "kind": "LinkedField",
                                                "name": "logo",
                                                "plural": false,
                                                "selections": (v228/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PageSectionActorsList",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          (v234/*: any*/)
                                        ],
                                        "type": "PageSectionPagesList",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/),
                                          (v233/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isPageSectionWithHeadingData"
                                          }
                                        ],
                                        "type": "PageSectionFilesList",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "blocksDisplayMode",
                                            "storageKey": null
                                          },
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v207/*: any*/),
                                          (v208/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FeaturedContentBlock",
                                            "kind": "LinkedField",
                                            "name": "featuredContentBlocks",
                                            "plural": true,
                                            "selections": [
                                              (v38/*: any*/),
                                              (v8/*: any*/),
                                              (v10/*: any*/),
                                              (v216/*: any*/),
                                              (v73/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Image",
                                                "kind": "LinkedField",
                                                "name": "image",
                                                "plural": false,
                                                "selections": [
                                                  (v73/*: any*/),
                                                  (v224/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ResponsiveImage",
                                                "kind": "LinkedField",
                                                "name": "originalImage",
                                                "plural": false,
                                                "selections": [
                                                  (v224/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Image",
                                                    "kind": "LinkedField",
                                                    "name": "large",
                                                    "plural": false,
                                                    "selections": (v74/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v8/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v246/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "blocksPerRow",
                                            "storageKey": null
                                          },
                                          (v230/*: any*/),
                                          (v231/*: any*/)
                                        ],
                                        "type": "PageSectionFeaturedContent",
                                        "abstractKey": null
                                      },
                                      (v213/*: any*/),
                                      (v214/*: any*/),
                                      (v215/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          (v218/*: any*/),
                                          (v217/*: any*/),
                                          (v73/*: any*/),
                                          (v219/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isEmpty",
                                            "storageKey": null
                                          },
                                          (v220/*: any*/),
                                          (v207/*: any*/),
                                          (v208/*: any*/),
                                          (v222/*: any*/),
                                          (v223/*: any*/),
                                          (v229/*: any*/)
                                        ],
                                        "type": "PageSectionEmbed",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          (v237/*: any*/),
                                          (v238/*: any*/),
                                          (v209/*: any*/),
                                          (v210/*: any*/),
                                          (v246/*: any*/),
                                          (v239/*: any*/),
                                          (v240/*: any*/)
                                        ],
                                        "type": "PageSectionParticipativeModuleResults",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v216/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "mapHeight",
                                            "storageKey": null
                                          },
                                          (v174/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "map",
                                            "plural": false,
                                            "selections": [
                                              (v38/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ParticipativeModule",
                                                    "kind": "LinkedField",
                                                    "name": "participativeModule",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ParticipativeModuleAuthorizations",
                                                        "kind": "LinkedField",
                                                        "name": "authorizations",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "contributionsDisplayAuthorized",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v28/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "visualization",
                                                        "plural": false,
                                                        "selections": [
                                                          (v38/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v189/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ParticipativeModule",
                                                                "kind": "LinkedField",
                                                                "name": "participativeModule",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Theme",
                                                                    "kind": "LinkedField",
                                                                    "name": "themes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v8/*: any*/),
                                                                      (v172/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v8/*: any*/),
                                                                  (v28/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "contributionsZIndexOffset",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "type": "ContributionsMap",
                                                            "abstractKey": null
                                                          },
                                                          (v8/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v8/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "VisualizationMap",
                                                "abstractKey": null
                                              },
                                              (v248/*: any*/),
                                              (v28/*: any*/),
                                              (v8/*: any*/),
                                              (v174/*: any*/),
                                              (v175/*: any*/),
                                              (v176/*: any*/),
                                              (v177/*: any*/),
                                              (v178/*: any*/),
                                              (v179/*: any*/),
                                              (v180/*: any*/),
                                              (v181/*: any*/),
                                              (v182/*: any*/),
                                              (v183/*: any*/),
                                              (v186/*: any*/),
                                              (v187/*: any*/),
                                              (v188/*: any*/),
                                              (v189/*: any*/),
                                              (v195/*: any*/),
                                              (v198/*: any*/),
                                              (v202/*: any*/),
                                              (v203/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PageSectionMap",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SearchConfiguration",
                                            "kind": "LinkedField",
                                            "name": "searchConfiguration",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "displayOptionsByDefault",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PageSectionSearchBox",
                                        "abstractKey": null
                                      },
                                      (v235/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v211/*: any*/),
                                          (v230/*: any*/),
                                          (v231/*: any*/),
                                          (v232/*: any*/),
                                          (v212/*: any*/)
                                        ],
                                        "type": "PageSectionSidebarBanner",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v119/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "displayLabel",
                                            "storageKey": null
                                          },
                                          (v43/*: any*/)
                                        ],
                                        "type": "PageSectionMapElementFeatureAttribute",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v64/*: any*/),
                                          (v216/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "defaultAcceptsCookiesValue",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PageSectionCookiesConsentsConfiguration",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v249/*: any*/),
                                        "type": "PageSectionSitemap",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v249/*: any*/),
                                        "type": "PageSectionInformationSearch",
                                        "abstractKey": null
                                      },
                                      (v236/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v39/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": "sections(first:2147483647)"
                          },
                          {
                            "alias": null,
                            "args": (v149/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "Page_sections",
                            "kind": "LinkedHandle",
                            "name": "sections"
                          }
                        ],
                        "type": "ResourceWithSections",
                        "abstractKey": "__isResourceWithSections"
                      }
                    ],
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "visualization",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v8/*: any*/),
                          (v248/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ParticipativeModule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sidebar",
                        "kind": "LinkedField",
                        "name": "sidebar",
                        "plural": false,
                        "selections": [
                          (v244/*: any*/),
                          (v245/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v47/*: any*/),
                              (v48/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MapElementPointStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": [
                                  (v191/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MapElementPoint",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CityWalk",
                        "kind": "LinkedField",
                        "name": "cityWalk",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CityWalkWaypoint",
                            "kind": "LinkedField",
                            "name": "waypoints",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "indexLabel",
                                "storageKey": null
                              },
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CityWalk",
                                "kind": "LinkedField",
                                "name": "cityWalk",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v140/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "waypointsCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CityWalkWaypoint",
                                    "kind": "LinkedField",
                                    "name": "waypoints",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "element",
                                        "plural": false,
                                        "selections": (v197/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CityWalkContribution",
                                    "kind": "LinkedField",
                                    "name": "activeContribution",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isComplete",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v38/*: any*/),
                                      (v174/*: any*/),
                                      (v175/*: any*/),
                                      (v176/*: any*/),
                                      (v177/*: any*/),
                                      (v178/*: any*/),
                                      (v179/*: any*/),
                                      (v180/*: any*/),
                                      (v181/*: any*/),
                                      (v182/*: any*/),
                                      (v183/*: any*/),
                                      (v186/*: any*/),
                                      (v187/*: any*/),
                                      (v188/*: any*/),
                                      (v189/*: any*/),
                                      (v195/*: any*/),
                                      (v198/*: any*/),
                                      (v202/*: any*/),
                                      (v203/*: any*/)
                                    ],
                                    "type": "Map",
                                    "abstractKey": "__isMap"
                                  }
                                ],
                                "type": "CityWalk",
                                "abstractKey": null
                              }
                            ],
                            "type": "ParticipativeModuleVisualization",
                            "abstractKey": "__isParticipativeModuleVisualization"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CityWalkWaypoint",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v82/*: any*/),
              (v83/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentPage",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  (v216/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCorrection",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "correctionTextOnlyOnWrongAnswers",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  (v85/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "validateContribution",
                    "storageKey": null
                  },
                  (v91/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formStepBack",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayStepsProgression",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v92/*: any*/),
                  (v93/*: any*/),
                  (v95/*: any*/),
                  (v94/*: any*/),
                  (v96/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModule",
                "kind": "LinkedField",
                "name": "participativeModule",
                "plural": false,
                "selections": [
                  (v86/*: any*/),
                  (v87/*: any*/),
                  (v88/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visualization",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v89/*: any*/),
                      (v8/*: any*/),
                      (v140/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v28/*: any*/),
                  (v10/*: any*/),
                  (v141/*: any*/),
                  (v142/*: any*/)
                ],
                "storageKey": null
              },
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fromAnonymous",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v250/*: any*/),
                      (v8/*: any*/),
                      (v251/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormFieldDisplayCondition",
                        "kind": "LinkedField",
                        "name": "displayConditions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formFieldName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormFieldDisplayConditionOption",
                            "kind": "LinkedField",
                            "name": "conditionOptions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "otherOption",
                                "storageKey": null
                              },
                              (v118/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v99/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSeparator",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "displayConditionAnswers",
                    "plural": true,
                    "selections": [
                      (v38/*: any*/),
                      (v252/*: any*/),
                      (v107/*: any*/),
                      (v253/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v257/*: any*/),
                          (v259/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerString",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v257/*: any*/),
                          (v260/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerText",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      (v261/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v257/*: any*/),
                          (v262/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerRichText",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v263/*: any*/),
                      (v264/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v265/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerFile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v252/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v269/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v270/*: any*/)
                    ],
                    "type": "AnswerCheckBoxes",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v112/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v271/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerBudgetDispatcher",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v122/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v272/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerThemes",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v125/*: any*/),
                      (v273/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v274/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerEvents",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      (v275/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v276/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerEmailWithConsents",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      (v277/*: any*/),
                      (v278/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v256/*: any*/),
                          (v254/*: any*/),
                          (v279/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v129/*: any*/)
                    ],
                    "type": "AnswerOralInterview",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v252/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v280/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerSortableList",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v281/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          (v282/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerMatrix",
                    "abstractKey": null
                  },
                  (v283/*: any*/),
                  (v284/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v256/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v38/*: any*/),
                          (v8/*: any*/),
                          (v253/*: any*/),
                          (v99/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v257/*: any*/),
                                  (v259/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerString",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v257/*: any*/),
                                  (v260/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerText",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v261/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v257/*: any*/),
                                  (v262/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerRichText",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v263/*: any*/),
                              (v264/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v265/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerFile",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v252/*: any*/),
                              (v107/*: any*/),
                              (v108/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v269/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v270/*: any*/)
                            ],
                            "type": "AnswerCheckBoxes",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v112/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v271/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerBudgetDispatcher",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v122/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v272/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerThemes",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v125/*: any*/),
                              (v273/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v274/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerEvents",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v275/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v276/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerEmailWithConsents",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v277/*: any*/),
                              (v278/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v256/*: any*/),
                                  (v254/*: any*/),
                                  (v279/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v129/*: any*/)
                            ],
                            "type": "AnswerOralInterview",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v252/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v280/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerSortableList",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v107/*: any*/),
                              (v108/*: any*/),
                              (v281/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "formField",
                                "plural": false,
                                "selections": [
                                  (v119/*: any*/),
                                  (v250/*: any*/),
                                  (v254/*: any*/),
                                  (v255/*: any*/),
                                  (v256/*: any*/),
                                  (v282/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnswerMatrix",
                            "abstractKey": null
                          },
                          (v283/*: any*/),
                          (v284/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerAddress",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v119/*: any*/),
                          (v254/*: any*/),
                          (v255/*: any*/),
                          (v256/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "goal",
                                "storageKey": null
                              },
                              (v134/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minAmount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maxAmount",
                                "storageKey": null
                              }
                            ],
                            "type": "FormFieldBudget",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerBudgetChapter",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              (v251/*: any*/),
                              (v8/*: any*/),
                              (v119/*: any*/),
                              (v250/*: any*/),
                              (v254/*: any*/),
                              (v255/*: any*/),
                              (v256/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormFieldOptionBudgetLine",
                                    "kind": "LinkedField",
                                    "name": "budgetLines",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v26/*: any*/),
                                      (v111/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "withOptions",
                                        "storageKey": null
                                      },
                                      (v247/*: any*/),
                                      (v268/*: any*/),
                                      (v216/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BudgetLineOption",
                                        "kind": "LinkedField",
                                        "name": "budgetLineOptions",
                                        "plural": true,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v119/*: any*/),
                                          (v111/*: any*/),
                                          (v241/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "FormFieldBudgetChapter",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v252/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerBudget",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finalizeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              (v25/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "map",
                "plural": false,
                "selections": [
                  (v38/*: any*/),
                  (v248/*: any*/),
                  (v28/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementThemeStyle",
                        "kind": "LinkedField",
                        "name": "newContributionMarkerStyle",
                        "plural": false,
                        "selections": (v171/*: any*/),
                        "storageKey": null
                      },
                      (v204/*: any*/)
                    ],
                    "type": "ContributionsMap",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v11/*: any*/),
              (v98/*: any*/),
              (v136/*: any*/),
              (v137/*: any*/),
              (v28/*: any*/),
              (v139/*: any*/),
              (v143/*: any*/),
              (v163/*: any*/),
              (v164/*: any*/),
              (v34/*: any*/),
              (v166/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v167/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stepIndex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stepsTotal",
                    "storageKey": null
                  }
                ],
                "type": "FormAnswerInterface",
                "abstractKey": "__isFormAnswerInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forceAnonymousContributions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "authorizations",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WithAnonymousMode",
                "abstractKey": "__isWithAnonymousMode"
              },
              (v169/*: any*/),
              (v170/*: any*/),
              (v159/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContributionMarkerEdge",
            "kind": "LinkedField",
            "name": "newContributionMarkerEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionMarker",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v173/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v90/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a80989277728baa920b1ad126fed9430",
    "id": null,
    "metadata": {},
    "name": "ValidateContributionMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateContributionMutation(\n  $answers: [AnswerInput]\n  $contribuableId: ID!\n  $contributionId: ID!\n  $currentPageId: ID!\n  $commentsCount: Int\n  $commentsCursor: String\n  $edit: Boolean\n) {\n  validateContribution(contribuableId: $contribuableId, contributionId: $contributionId, currentPageId: $currentPageId, answers: $answers, edit: $edit) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    newContributionEdge {\n      node {\n        id\n        isFeatured\n        title\n        isFromAdminUser\n        authorizations {\n          votesDisplayAuthorized\n          votesSubmissionAuthorized\n          commentsDisplayAuthorized\n          commentsSubmissionAuthorized\n          id\n        }\n        themes {\n          ...ContributionThemesLabel_themes\n          id\n        }\n        additionalDisplayableFields {\n          id\n          ...AnswerFormField_field\n        }\n        ...ContributionHeader_contribution\n        ...ContributionCommentsPanel_contribution\n        ...VoteButtons_votable\n        ...ReactableMeasures_reactable\n        ...ContributionContent_contribution\n        ...Report_reportable\n        ...ContributionBookmarkButton_contribution\n        hasLocation\n        author {\n          name\n          ...UserAvatar_user\n          ...UserAuthorName_user\n          id\n        }\n        slug\n        theme {\n          primaryColor\n          ...ContributionTheme_theme\n          id\n        }\n        participativeModule {\n          slug\n          visualization {\n            __typename\n            ... on ContributionsGrid {\n              bannerImageUrl\n            }\n            id\n          }\n          id\n        }\n        votes {\n          up\n          id\n        }\n        isBookmarked\n        isMine\n        reactionsCount\n        ...ContributionsDatavizListThemeContribution_contribution\n        comments(first: $commentsCount, after: $commentsCursor) {\n          edges {\n            node {\n              id\n              ...Comment_comment\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n    contribution {\n      id\n      title\n      content\n      theme {\n        id\n        contributionsCount\n        parent {\n          id\n          contributionsCount\n          parent {\n            id\n            contributionsCount\n          }\n        }\n        primaryColor\n        ...ContributionTheme_theme\n      }\n      marker {\n        contributionSlug\n        themeId\n        latitude\n        longitude\n        ...ContributionsMapContributionTooltip_contributionMarker\n        id\n      }\n      contribuable {\n        __typename\n        id\n        ... on Event {\n          visualization {\n            __typename\n            ... on EventVisualization {\n              startsAt\n              endsAt\n              alreadySubmitted\n              remainingSeats\n              maximumSeats\n              authorizations {\n                displayMaximumSeats\n                displayRemainingSeats\n              }\n              ...EventMap_event\n            }\n            id\n          }\n          authorizations {\n            contributionsSubmissionAuthorized\n          }\n          ...TitleBarWithAction_resource\n          ...SubscribeToEventButton_participativeModule\n          ...EventCalendarDropdownButton_participativeModule\n          ...PageSections_page\n        }\n        ... on CityWalkWaypoint {\n          id\n          title\n          isFilled\n          isFillable\n          waypointIndex\n          nextWaypointId\n          sidebar {\n            ...Sidebar_sidebar\n            id\n          }\n          element {\n            __typename\n            id\n            ... on MapElementPoint {\n              latitude\n              longitude\n              style {\n                iconStyle {\n                  ... on MapElementImageStyle {\n                    __isMapElementImageStyle: __typename\n                    iconClass\n                    color\n                    contrastColor\n                    width\n                    height\n                    anchor\n                    anchorOffsetX\n                    anchorOffsetY\n                    opacity\n                    image {\n                      __typename\n                      ... on Image {\n                        url\n                      }\n                      ... on StaticImage {\n                        url\n                      }\n                    }\n                  }\n                  id\n                }\n                id\n              }\n            }\n          }\n          cityWalk {\n            slug\n            cityWalkWaypointsDefaultZoom\n            waypoints {\n              ...CityWalkTimeline_waypoints\n              id\n            }\n            activeContribution {\n              id\n              didCompleteAllWaypoints\n            }\n            authorizations {\n              contributionsSubmissionAuthorized\n            }\n            customIntlMessages {\n              identifier\n              message\n              id\n            }\n            id\n            ... on ParticipativeModuleVisualization {\n              __isParticipativeModuleVisualization: __typename\n              ... on CityWalk {\n                ...MapContextProvider_map\n                ...CityWalkLayout_cityWalk\n              }\n            }\n          }\n        }\n      }\n      isDraft\n      formHash\n      currentPage {\n        __typename\n        id\n      }\n      authorizations {\n        toggleAnonymousMode\n        id\n        votesDisplayAuthorized\n        votesSubmissionAuthorized\n        commentsDisplayAuthorized\n        commentsSubmissionAuthorized\n      }\n      participativeModule {\n        disclaimer\n        completeMessage\n        authorizations {\n          contributionsSubmissionAuthorized\n          unauthorizedMessages {\n            contributionsSubmissionAuthorized\n          }\n        }\n        visualization {\n          __typename\n          path\n          id\n          ... on ContributionsGrid {\n            bannerImageUrl\n          }\n        }\n        id\n        slug\n      }\n      ...FormDisclaimer_contribution\n      ...FormPage_contribution\n      ...FormComplete_contribution\n      isFeatured\n      isFromAdminUser\n      themes {\n        ...ContributionThemesLabel_themes\n        id\n      }\n      additionalDisplayableFields {\n        id\n        ...AnswerFormField_field\n      }\n      ...ContributionHeader_contribution\n      ...ContributionCommentsPanel_contribution\n      ...VoteButtons_votable\n      ...ReactableMeasures_reactable\n      ...ContributionContent_contribution\n      ...Report_reportable\n      ...ContributionBookmarkButton_contribution\n      hasLocation\n      author {\n        name\n        ...UserAvatar_user\n        ...UserAuthorName_user\n        id\n      }\n      slug\n      votes {\n        up\n        id\n      }\n      isBookmarked\n      isMine\n      reactionsCount\n      ...ContributionsDatavizListThemeContribution_contribution\n      comments(first: $commentsCount, after: $commentsCursor) {\n        edges {\n          node {\n            id\n            ...Comment_comment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    newContributionMarkerEdge {\n      node {\n        contributionSlug\n        themeId\n        latitude\n        longitude\n        ...ContributionsMapContributionTooltip_contributionMarker\n        id\n      }\n    }\n  }\n}\n\nfragment AnalyticsDatumCardRow_analyticsDatum on AnalyticsDatumInterface {\n  __isAnalyticsDatumInterface: __typename\n  label\n  count\n}\n\nfragment AnonymousContributionFormBanner_anonymousMode on WithAnonymousMode {\n  __isWithAnonymousMode: __typename\n  forceAnonymousContributions\n  authorizations {\n    __typename\n    toggleAnonymousMode\n    id\n  }\n}\n\nfragment AnswerAddress_answer on AnswerAddress {\n  formField {\n    __typename\n    id\n    fieldName\n    hide\n  }\n  answers {\n    __typename\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...ShallowAnswer_answer\n  }\n}\n\nfragment AnswerBudgetChapter_answer on AnswerBudgetChapter {\n  values\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudgetChapter {\n      budgetLines {\n        id\n        name\n        value\n        withOptions\n        displayMode\n        maximumSelectableOptions\n        description\n        budgetLineOptions {\n          id\n          label\n          value\n          position\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerBudgetDispatcher_answer on AnswerBudgetDispatcher {\n  id\n  dispatchedBudgetValues {\n    optionId\n    value\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldBudgetDispatcher {\n      budget\n      maxBudgetPerOption\n      minBudgetToSpend\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerBudget_answer on AnswerBudget {\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudget {\n      goal\n      unit\n      minAmount\n      maxAmount\n    }\n    id\n  }\n  answers {\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...AnswerBudgetChapter_answer\n  }\n}\n\nfragment AnswerCheckBoxes_answer on AnswerCheckBoxes {\n  values\n  other\n  otherValue\n  formField {\n    __typename\n    id\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldCheckBoxes {\n      displayOtherField\n      otherFieldLabel\n      singleOptionSelection\n      maximumSelectableOptions\n      selectableType\n      listedOptions {\n        id\n        name\n        isCorrect\n        correctionText\n      }\n    }\n  }\n  ...FormFieldOptionsSelect_answer\n}\n\nfragment AnswerEmailWithConsents_answer on AnswerEmailWithConsents {\n  id\n  content\n  consentGiven\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEmailWithConsents {\n      displayEmailConsent\n      consentLabel\n    }\n  }\n}\n\nfragment AnswerEvents_answer on AnswerEvents {\n  id\n  eventIds\n  none\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEvents {\n      maximumEvents\n      allowNone\n      options {\n        id\n        name: title\n      }\n    }\n  }\n}\n\nfragment AnswerFile_answer on AnswerFile {\n  sourcesAttachmentToken\n  sources {\n    key\n    name\n    url\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldFile {\n      multiple\n      maxFiles\n      allowedFileExtensions\n      maximumFileSize\n    }\n  }\n}\n\nfragment AnswerFormField_field on AnswerFormField {\n  title\n  answer {\n    __typename\n    ...AnswerPreview_answer\n    id\n  }\n}\n\nfragment AnswerMatrix_answer on AnswerMatrix {\n  id\n  other\n  otherValue\n  itemOptions {\n    other\n    item {\n      id\n    }\n    option {\n      id\n    }\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldMatrix {\n      maximumSelectableOptions\n      singleOptionSelection\n      displayOtherField\n      otherFieldLabel\n      items {\n        id\n        label\n      }\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerOralInterview_answer on AnswerOralInterview {\n  content\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    fieldName\n    hide\n  }\n  ...InterviewChatSection_answer\n  ...InterviewCompletionSection_answer\n  ...InterviewControlsSection_answer\n  ...InterviewIntroSection_answer\n  ...InterviewResponseSection_answer\n}\n\nfragment AnswerPresentationTextZone_answer on AnswerPresentationTextZone {\n  formField {\n    __typename\n    ... on FormFieldPresentationTextZone {\n      content\n    }\n    id\n  }\n}\n\nfragment AnswerPresentationTitle_answer on AnswerPresentationTitle {\n  formField {\n    __typename\n    label\n    id\n  }\n}\n\nfragment AnswerPreviewAddress_answer on AnswerAddress {\n  id\n  answers {\n    __typename\n    id\n    ...ShallowAnswerPreview_answer\n  }\n}\n\nfragment AnswerPreviewBudgetDispatcher_answer on AnswerBudgetDispatcher {\n  dispatchedBudgetValues {\n    optionId\n    value\n    id\n  }\n  formField {\n    __typename\n    ... on FormFieldBudgetDispatcher {\n      maxBudgetPerOption\n      options {\n        __typename\n        id\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewBudget_answer on AnswerBudget {\n  balance\n  formField {\n    __typename\n    ... on FormFieldBudget {\n      unit\n    }\n    id\n  }\n  answers {\n    id\n    balance\n    formField {\n      __typename\n      label\n      id\n    }\n    budgetLines {\n      value\n      stepLabel\n      option {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerPreviewCheckBoxes_answer on AnswerCheckBoxes {\n  formattedValues\n  other\n  otherValue\n  formField {\n    __typename\n    ... on FormFieldCheckBoxes {\n      otherFieldLabel\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewEmailWithConsents_answer on AnswerEmailWithConsents {\n  content\n}\n\nfragment AnswerPreviewEvents_answer on AnswerEvents {\n  eventIds\n  formField {\n    __typename\n    ... on FormFieldEvents {\n      options {\n        id\n        name: title\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewFile_answer on AnswerFile {\n  id\n  urls\n  sources {\n    id\n    name\n    url\n  }\n}\n\nfragment AnswerPreviewMatrix_answer on AnswerMatrix {\n  itemOptions {\n    item {\n      id\n    }\n    option {\n      id\n    }\n    id\n  }\n  formField {\n    __typename\n    ... on FormFieldMatrix {\n      items {\n        id\n        label\n      }\n      options {\n        __typename\n        id\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewOralInterview_answer on AnswerOralInterview {\n  individualSummary\n}\n\nfragment AnswerPreviewPresentationSeparator_answer on AnswerPresentationSeparator {\n  id\n}\n\nfragment AnswerPreviewPresentationTextZone_answer on AnswerPresentationTextZone {\n  id\n}\n\nfragment AnswerPreviewPresentationTitle_answer on AnswerPresentationTitle {\n  id\n  formField {\n    __typename\n    label\n    id\n  }\n}\n\nfragment AnswerPreviewRichText_answer on AnswerRichText {\n  content\n}\n\nfragment AnswerPreviewSortableList_answer on AnswerSortableList {\n  formattedValues\n}\n\nfragment AnswerPreviewString_answer on AnswerString {\n  content\n}\n\nfragment AnswerPreviewText_answer on AnswerText {\n  content\n}\n\nfragment AnswerPreviewThemes_answer on AnswerThemes {\n  selectedThemeIds\n  formField {\n    __typename\n    ... on FormFieldThemes {\n      themes {\n        label\n        value\n        children {\n          label\n          value\n          children {\n            label\n            value\n            children {\n              label\n              value\n              children {\n                label\n                value\n                children {\n                  label\n                  value\n                  children {\n                    label\n                    value\n                    children {\n                      label\n                      value\n                      children {\n                        label\n                        value\n                        children {\n                          label\n                          value\n                          children {\n                            label\n                            value\n                            id\n                          }\n                          id\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreview_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...ShallowAnswerPreview_answer\n  ...AnswerPreviewAddress_answer\n  ...AnswerPreviewBudget_answer\n}\n\nfragment AnswerRichText_answer on AnswerRichText {\n  id\n  content\n  contentAttachmentToken\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    id\n  }\n  ...SimilarAnswersSuggestions_answer\n}\n\nfragment AnswerSortableList_answer on AnswerSortableList {\n  id\n  values\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldSortableList {\n      minimumSelectableOptions\n      maximumSelectableOptions\n      options {\n        __typename\n        id\n        name\n        description\n      }\n    }\n  }\n}\n\nfragment AnswerString_answer on AnswerString {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldString {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerText_answer on AnswerText {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldText {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerThemes_answer on AnswerThemes {\n  selectedThemeIds\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldThemes {\n      maximumThemes\n      themes {\n        label\n        value\n        children {\n          label\n          value\n          children {\n            label\n            value\n            children {\n              label\n              value\n              children {\n                label\n                value\n                children {\n                  label\n                  value\n                  children {\n                    label\n                    value\n                    children {\n                      label\n                      value\n                      children {\n                        label\n                        value\n                        children {\n                          label\n                          value\n                          children {\n                            label\n                            value\n                            id\n                          }\n                          id\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment Answer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...ShallowAnswer_answer\n  ...AnswerAddress_answer\n  ...AnswerBudget_answer\n  ...useAnswerShouldBeConditionnallyHidden_answer\n}\n\nfragment Answers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  isSeparator\n  ...Answer_answer\n  ...useFilterConditionnallyHiddenAnswers_answers\n}\n\nfragment AudioPlayer_audio on Attachment {\n  url\n}\n\nfragment Breadcrumbs_page on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  title\n  ancestors {\n    __typename\n    id\n    title\n    resourcePath\n  }\n}\n\nfragment CalendarDayEventsPanel_events on CalendarResource {\n  id\n  ...CalendarResourceItem_event\n}\n\nfragment CalendarResourceItem_event on CalendarResource {\n  title\n  url\n  color\n  startsAt\n  endsAt\n  eventMode\n}\n\nfragment Calendar_section on PageSectionCalendar {\n  resources {\n    id\n    color\n    startsAt\n    endsAt\n    ...CalendarDayEventsPanel_events\n  }\n}\n\nfragment CardStep_step on Step {\n  name\n  startDate\n  endDate\n  isCurrent\n  position\n}\n\nfragment CityWalkCompleteDialog_cityWalk on CityWalk {\n  activeContribution {\n    id\n  }\n  customIntlMessages {\n    identifier\n    message\n    id\n  }\n}\n\nfragment CityWalkComplete_cityWalk on CityWalk {\n  id\n  slug\n}\n\nfragment CityWalkLayout_cityWalk on CityWalk {\n  slug\n  waypointsCount\n  waypoints {\n    id\n    element {\n      __typename\n      id\n    }\n  }\n  activeContribution {\n    isComplete\n    id\n  }\n  ...CityWalkCompleteDialog_cityWalk\n  ...CityWalkComplete_cityWalk\n  ...MapWithSidebarLayout_map\n}\n\nfragment CityWalkTimelineWaypoint_waypoint on CityWalkWaypoint {\n  id\n  indexLabel\n  isFilled\n  cityWalk {\n    slug\n    id\n  }\n}\n\nfragment CityWalkTimeline_waypoints on CityWalkWaypoint {\n  id\n  ...CityWalkTimelineWaypoint_waypoint\n}\n\nfragment CommentCard_comment on Comment {\n  id\n  content\n  createdAt\n  commentsCount\n  isFromAdminUser\n  author {\n    __typename\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    requiresModeration\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    id\n  }\n  ...VoteButtons_votable\n  ...Report_reportable\n  ...ReactableMeasures_reactable\n}\n\nfragment Comment_comment on Comment {\n  id\n  title\n  ...CommentCard_comment\n  isFromAdminUser\n  comments(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...CommentCard_comment\n        comments(first: 2147483647) {\n          edges {\n            node {\n              id\n              ...CommentCard_comment\n              comments(first: 2147483647) {\n                edges {\n                  node {\n                    id\n                    ...CommentCard_comment\n                    comments(first: 2147483647) {\n                      edges {\n                        node {\n                          id\n                          ...CommentCard_comment\n                          comments(first: 2147483647) {\n                            edges {\n                              node {\n                                id\n                                ...CommentCard_comment\n                                comments(first: 2147483647) {\n                                  edges {\n                                    node {\n                                      id\n                                      ...CommentCard_comment\n                                      comments(first: 2147483647) {\n                                        edges {\n                                          node {\n                                            id\n                                            ...CommentCard_comment\n                                            comments(first: 2147483647) {\n                                              edges {\n                                                node {\n                                                  id\n                                                  ...CommentCard_comment\n                                                  comments(first: 2147483647) {\n                                                    edges {\n                                                      node {\n                                                        id\n                                                        ...CommentCard_comment\n                                                        __typename\n                                                      }\n                                                      cursor\n                                                    }\n                                                    pageInfo {\n                                                      endCursor\n                                                      hasNextPage\n                                                    }\n                                                  }\n                                                  __typename\n                                                }\n                                                cursor\n                                              }\n                                              pageInfo {\n                                                endCursor\n                                                hasNextPage\n                                              }\n                                            }\n                                            __typename\n                                          }\n                                          cursor\n                                        }\n                                        pageInfo {\n                                          endCursor\n                                          hasNextPage\n                                        }\n                                      }\n                                      __typename\n                                    }\n                                    cursor\n                                  }\n                                  pageInfo {\n                                    endCursor\n                                    hasNextPage\n                                  }\n                                }\n                                __typename\n                              }\n                              cursor\n                            }\n                            pageInfo {\n                              endCursor\n                              hasNextPage\n                            }\n                          }\n                          __typename\n                        }\n                        cursor\n                      }\n                      pageInfo {\n                        endCursor\n                        hasNextPage\n                      }\n                    }\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CommentsList_comments on Comment {\n  id\n  ...Comment_comment\n}\n\nfragment ContainerWithSidebar_sidebar on Sidebar {\n  hasSections\n  ...Sidebar_sidebar\n}\n\nfragment ContributionBookmarkButton_contribution on Contribution {\n  id\n  isBookmarked\n  authorizations {\n    bookmarksCreationAuthorized\n    id\n  }\n}\n\nfragment ContributionCardThemes_contribution on Contribution {\n  theme {\n    iconClass\n    primaryColor\n    primaryContrastColor\n    name\n    parent {\n      iconClass\n      primaryColor\n      primaryContrastColor\n      name\n      parent {\n        iconClass\n        primaryColor\n        primaryContrastColor\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ContributionCommentsPanel_contribution on Contribution {\n  id\n  title\n  totalCommentsCount\n  authorizations {\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    unauthorizedMessages {\n      submitComment\n      id\n    }\n    id\n  }\n  comments(first: $commentsCount, after: $commentsCursor) {\n    edges {\n      node {\n        ...CommentsList_comments\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ReactableMeasures_reactable\n}\n\nfragment ContributionContent_contribution on Contribution {\n  content\n  participativeModule {\n    collapseContributionsContent\n    contributionContentCollapsedHeight\n    id\n  }\n}\n\nfragment ContributionFormModalTitle_contribution on Contribution {\n  id\n  authorizations {\n    formStepBack\n    displayStepsProgression\n    id\n  }\n  ... on FormAnswerInterface {\n    __isFormAnswerInterface: __typename\n    stepIndex\n    stepsTotal\n    hasPreviousPage\n  }\n}\n\nfragment ContributionHeader_contribution on Contribution {\n  id\n  title\n  publishedAt\n  slug\n  author {\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    editContribution\n    contributorContactAuthorized\n    requiresModeration\n    id\n  }\n  participativeModule {\n    slug\n    id\n  }\n  ...ContributorContactButton_contribution\n  ...ContributionWithRequiredModerationBadge_contribution\n}\n\nfragment ContributionLocationMap_contribution on Contribution {\n  hasLocation\n  latitude\n  longitude\n  theme {\n    style {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  map {\n    __typename\n    ... on ContributionsMap {\n      newContributionMarkerStyle {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n      ...MapBase_map\n    }\n    ...MapContextProvider_map\n    id\n  }\n}\n\nfragment ContributionTheme_theme on Theme {\n  name\n  primaryColor\n  primaryContrastColor\n  ...ThemeImage_theme\n}\n\nfragment ContributionThemesLabel_themes on Theme {\n  id\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n}\n\nfragment ContributionWithRequiredModerationBadge_contribution on Contribution {\n  authorizations {\n    requiresModeration\n    id\n  }\n}\n\nfragment ContributionsDatavizListThemeContribution_contribution on Contribution {\n  slug\n  token\n  title\n  themes {\n    id\n    name\n  }\n  isFromAdminUser\n  author {\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  participativeModule {\n    slug\n    id\n  }\n  ...ContributionCardThemes_contribution\n  ...ReactableMeasures_reactable\n}\n\nfragment ContributionsMapContributionMarker_map on ContributionsMap {\n  contributionsZIndexOffset\n  participativeModule {\n    slug\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionTooltip_contributionMarker on ContributionMarker {\n  contributionSlug\n}\n\nfragment ContributionsMapContributionsMarkersManager_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsMap {\n      ...ContributionsMapContributionsMarkers_map\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsMarkers_map on ContributionsMap {\n  ...ContributionsMapThemeContributionsMarkers_map\n}\n\nfragment ContributionsMapThemeContributionsMarkers_map on ContributionsMap {\n  markersMaxClusterRadius\n  participativeModule {\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  ...ContributionsMapContributionMarker_map\n}\n\nfragment ContributorContactButton_contribution on Contribution {\n  slug\n  authorizations {\n    contributorContactAuthorized\n    unauthorizedMessages {\n      contributorContact\n      id\n    }\n    id\n  }\n  participativeModule {\n    slug\n    visualization {\n      __typename\n      customIntlMessages {\n        identifier\n        message\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment DownVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    down\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment EventCalendarDropdownButton_participativeModule on Event {\n  title\n  slug\n  visualization {\n    __typename\n    ... on EventVisualization {\n      fullAddress\n      startsAt\n      endsAt\n      authorizations {\n        allowAddingEventsToCalendar\n      }\n    }\n    id\n  }\n}\n\nfragment EventCard_participativeModule on Event {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n      placeName\n      address\n      zip\n      city\n    }\n    id\n  }\n}\n\nfragment EventMap_event on EventVisualization {\n  latitude\n  longitude\n  marker {\n    ...InformativeMarker_marker\n    id\n  }\n  map {\n    ...MapBase_map\n    id\n  }\n}\n\nfragment FeaturedContentBlockImage_block on FeaturedContentBlock {\n  url\n  originalImage {\n    altText\n    large {\n      url\n    }\n    id\n  }\n}\n\nfragment FeaturedContentBlockText_block on FeaturedContentBlock {\n  title\n  description\n  url\n  image {\n    url\n    altText\n  }\n}\n\nfragment FeaturedContentBlock_block on FeaturedContentBlock {\n  title\n  ...FeaturedContentBlockText_block\n  ...FeaturedContentBlockImage_block\n}\n\nfragment FeaturedContentCarousel_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  autoplay\n  slidesInterval\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment FeaturedContentGrid_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment FormComplete_contribution on Contribution {\n  participativeModule {\n    slug\n    title\n    completeMessage\n    id\n  }\n  ...ContributionFormModalTitle_contribution\n}\n\nfragment FormDisclaimer_contribution on Contribution {\n  authorizations {\n    toggleAnonymousMode\n    id\n  }\n  participativeModule {\n    id\n    slug\n    title\n    disclaimer\n  }\n}\n\nfragment FormFieldOptionsSelect_answer on AnswerCheckBoxes {\n  selectedOptions {\n    id\n    name\n  }\n  formField {\n    __typename\n    id\n    ... on FormFieldCheckBoxes {\n      optionsSearchable\n    }\n  }\n}\n\nfragment FormPage_contribution on Contribution {\n  id\n  isDraft\n  hasNextPage\n  fromAnonymous\n  answers {\n    __typename\n    formField {\n      __typename\n      required\n      id\n    }\n    ...Answers_answers\n    id\n  }\n  finalizeUrl\n  currentPage {\n    __typename\n    id\n    title\n    description\n    isCorrection\n    correctionTextOnlyOnWrongAnswers\n  }\n  hasPreviousPage\n  authorizations {\n    validateContribution\n    editContribution\n    formStepBack\n    id\n  }\n  contribuable {\n    __typename\n    id\n    ... on ParticipativeModule {\n      visualization {\n        __typename\n        ... on Map {\n          __isMap: __typename\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ContributionFormModalTitle_contribution\n  ...ContributionLocationMap_contribution\n  ...AnonymousContributionFormBanner_anonymousMode\n}\n\nfragment InformativeMarker_marker on MapMarker {\n  __isMapMarker: __typename\n  targetUrl\n  tooltipContent\n  latitude\n  longitude\n  markerStyle {\n    backgroundColor\n    id\n  }\n}\n\nfragment InterviewChatMessage_message on OralInterviewMessage {\n  role\n  text\n}\n\nfragment InterviewChatSection_answer on AnswerOralInterview {\n  messages {\n    ...InterviewChatMessage_message\n  }\n}\n\nfragment InterviewCompletionSection_answer on AnswerOralInterview {\n  individualSummary\n  formField {\n    __typename\n    ... on FormFieldOralInterview {\n      closingMessage\n    }\n    id\n  }\n}\n\nfragment InterviewControlsSection_answer on AnswerOralInterview {\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    required\n  }\n}\n\nfragment InterviewIntroSection_answer on AnswerOralInterview {\n  formField {\n    __typename\n    hint\n    id\n  }\n}\n\nfragment InterviewResponseSection_answer on AnswerOralInterview {\n  status\n  formField {\n    __typename\n    id\n  }\n}\n\nfragment LibraryFile_file on LibraryFile {\n  name\n  url\n  size\n  fileExtension\n}\n\nfragment LinkSlide_slide on Slide {\n  url\n}\n\nfragment MapBase_map on Map {\n  __isMap: __typename\n  id\n  zoomDefault\n  zoomMin\n  zoomMax\n  mobileZoomDefault\n  mobileZoomMin\n  mobileZoomMax\n  centerLatitude\n  centerLongitude\n  tileLayerUrl\n  mapDataAttribution\n  zoomLevels {\n    zoomLevelMin\n    zoomLevelMax\n    tileLayerUrl\n    mapDataAttribution\n    id\n  }\n  ...MapElementsVectorGrid_map\n}\n\nfragment MapClusterizedPointMarker_point on MapElementPoint {\n  id\n  hasInformationWindow\n  latitude\n  longitude\n  mapElementGeometryId\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  tooltip {\n    ...MapElementTooltip_tooltip\n    id\n  }\n}\n\nfragment MapClusterizedPointMarkers_map on Map {\n  __isMap: __typename\n  markersMaxClusterRadius\n  clusterizedPoints {\n    id\n    ...MapClusterizedPointMarker_point\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapContextProvider_map on Map {\n  __isMap: __typename\n  __typename\n  slug\n}\n\nfragment MapElementTooltip_tooltip on MapElementTooltip {\n  content\n}\n\nfragment MapElementsVectorGridTileLayerStyles_map on Map {\n  __isMap: __typename\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        __isMapElement: __typename\n        id\n        geometriesType\n        ... on MapElementCompoundFeature {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            shadowStyle {\n              offsetX\n              offsetY\n              blur\n              color\n              opacity\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPath {\n          style {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPoint {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPointStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementShape {\n          style {\n            zIndexOffset\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementShapeStyle {\n                  borderStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                    zoomLevels {\n                      zoomLevelMin\n                      zoomLevelMax\n                      style {\n                        __typename\n                        ... on MapElementPathStyle {\n                          color\n                          opacity\n                          style\n                          width\n                          zIndexOffset\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapElementsVectorGrid_map on Map {\n  __isMap: __typename\n  id\n  hasElements\n  vectorTileUrl\n  ...MapClusterizedPointMarkers_map\n  ...MapElementsVectorGridTileLayerStyles_map\n}\n\nfragment MapSidebarEventsList_eventsList on PageSectionSidebarEventsList {\n  id\n  title\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n}\n\nfragment MapWithSidebarLayout_map on Map {\n  __isMap: __typename\n  ...MapBase_map\n}\n\nfragment PageSectionActorsList_pageSection on PageSectionActorsList {\n  title\n  iconClass\n  description\n  actorsPerRow\n  contentAlignment\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  actors {\n    id\n    name\n    description\n    logo {\n      ...ResponsiveImage_image\n      id\n    }\n  }\n}\n\nfragment PageSectionAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionBanner_pageSection on PageSectionBanner {\n  autoplay\n  slidesInterval\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  slides {\n    id\n    ...Slide_slide\n  }\n}\n\nfragment PageSectionCalendar_pageSection on PageSectionCalendar {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...Calendar_section\n}\n\nfragment PageSectionCookiesConsentsConfiguration_pageSection on PageSectionCookiesConsentsConfiguration {\n  title\n  iconClass\n  description\n  defaultAcceptsCookiesValue\n}\n\nfragment PageSectionEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  hlsUrl\n  code\n  url\n  format\n  isEmpty\n  mediaTitle\n  collapsible\n  collapsedHeight\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionEventsList_pageSection on PageSectionEventsList {\n  title\n  description\n  displayMode\n  hideIfEmpty\n  events {\n    id\n    ...EventCard_participativeModule\n  }\n}\n\nfragment PageSectionFeaturedContent_pageSection on PageSectionFeaturedContent {\n  title\n  iconClass\n  description\n  blocksDisplayMode\n  columnsRatio\n  columnsOrder\n  collapsible\n  collapsedHeight\n  featuredContentBlocks {\n    __typename\n    id\n  }\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...FeaturedContentGrid_featuredContent\n  ...FeaturedContentCarousel_featuredContent\n}\n\nfragment PageSectionFilesList_pageSection on PageSectionFilesList {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    hasSections\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  files {\n    id\n    ...LibraryFile_file\n  }\n}\n\nfragment PageSectionInformationSearch_pageSection on PageSectionInformationSearch {\n  id\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionMapElementFeatureAttribute_pageSection on PageSectionMapElementFeatureAttribute {\n  label\n  displayLabel\n  content\n}\n\nfragment PageSectionMap_pageSection on PageSectionMap {\n  title\n  description\n  mapHeight\n  zoomDefault\n  map {\n    __typename\n    ... on VisualizationMap {\n      participativeModule {\n        authorizations {\n          contributionsDisplayAuthorized\n        }\n        ...ContributionsMapContributionsMarkersManager_participativeModule\n        id\n      }\n    }\n    ...MapContextProvider_map\n    ...MapBase_map\n    id\n  }\n}\n\nfragment PageSectionPagesList_pageSection on PageSectionPagesList {\n  title\n  iconClass\n  description\n  resourceTargets {\n    id\n    name\n    url\n  }\n}\n\nfragment PageSectionParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  iconClass\n  description\n  displayQuestionsLabel\n  displayParticipationData\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  title\n  description\n  iconClass\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n}\n\nfragment PageSectionSearchBox_pageSection on PageSectionSearchBox {\n  title\n  iconClass\n  description\n  searchConfiguration {\n    id\n    displayOptionsByDefault\n  }\n}\n\nfragment PageSectionSidebarAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionSidebarBanner_pageSection on PageSectionSidebarBanner {\n  fullHeight\n  autoplay\n  slidesInterval\n  slides {\n    id\n    ...Slide_slide\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarCalendar_pageSection on PageSectionCalendar {\n  title\n  description\n  ...Calendar_section\n}\n\nfragment PageSectionSidebarEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  code\n  url\n  hlsUrl\n  format\n  mediaTitle\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionSidebarEventsList_pageSection on PageSectionSidebarEventsList {\n  id\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n  ...MapSidebarEventsList_eventsList\n}\n\nfragment PageSectionSidebarFilesList_pageSection on PageSectionFilesList {\n  files {\n    id\n    ...LibraryFile_file\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarLinkBlock_pageSection on PageSectionSidebarLinkBlock {\n  title\n  subtitle\n  iconClass\n  url\n}\n\nfragment PageSectionSidebarPagesList_pageSection on PageSectionPagesList {\n  resourceTargets {\n    id\n    name\n    url\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  description\n  iconClass\n  displayQuestionsLabel\n  displayParticipationData\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarText_pageSection on PageSectionSidebarText {\n  content\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarUsersGroupRequestLinkBlock_pageSection on PageSectionSidebarUsersGroupRequestLinkBlock {\n  iconClass\n  addRequestTitle\n  removeRequestTitle\n  usersGroup {\n    id\n    name\n    alreadyGroupMember\n    alreadyRequested\n    authorizations {\n      sendJoinGroupRequest\n    }\n  }\n}\n\nfragment PageSectionSidebar_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionSidebarEmbed_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarPagesList_pageSection\n  ...PageSectionSidebarAnalyticsDataList_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n  ...PageSectionSidebarParticipativeModuleResults_pageSection\n  ...PageSectionSidebarParticipativeModulesList_pageSection\n  ...PageSectionSidebarCalendar_pageSection\n}\n\nfragment PageSectionSitemap_pageSection on PageSectionSitemap {\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionText_pageSection on PageSectionText {\n  content\n  collapsible\n  collapsedHeight\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n}\n\nfragment PageSection_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionText_pageSection\n  ...PageSectionBanner_pageSection\n  ...PageSectionParticipativeModulesList_pageSection\n  ...PageSectionEventsList_pageSection\n  ...PageSectionCalendar_pageSection\n  ...PageSectionActorsList_pageSection\n  ...PageSectionPagesList_pageSection\n  ...PageSectionFilesList_pageSection\n  ...PageSectionFeaturedContent_pageSection\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionEmbed_pageSection\n  ...PageSectionParticipativeModuleResults_pageSection\n  ...PageSectionMap_pageSection\n  ...PageSectionSearchBox_pageSection\n  ...PageSectionAnalyticsDataList_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionMapElementFeatureAttribute_pageSection\n  ...PageSectionCookiesConsentsConfiguration_pageSection\n  ...PageSectionSitemap_pageSection\n  ...PageSectionInformationSearch_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n}\n\nfragment PageSections_page on ResourceWithSections {\n  __isResourceWithSections: __typename\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        ...PageSection_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ParticipativeModuleCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  thumbUrl\n  visualization {\n    __typename\n    iconClass\n    id\n  }\n  currentStep {\n    ...CardStep_step\n    id\n  }\n  ...ParticipativeModuleMeasures_participativeModule\n}\n\nfragment ParticipativeModuleMeasures_participativeModule on ParticipativeModule {\n  authorizations {\n    votesDisplayAuthorized\n    votesDownAuthorized\n    contributionsCountDisplayAuthorized\n  }\n  votesUpCount\n  votesDownCount\n  contributionsCount\n}\n\nfragment ParticipativeModuleResultsFormFields_pageSection on PageSectionParticipativeModuleResults {\n  id\n  participativeModuleIds\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment Report_reportable on Reportable {\n  __isReportable: __typename\n  id\n}\n\nfragment ResponsiveImage_image on ResponsiveImage {\n  altText\n  large {\n    ratio\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  medium {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  small {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n}\n\nfragment ShallowAnswerPreview_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...AnswerPreviewString_answer\n  ...AnswerPreviewText_answer\n  ...AnswerPreviewRichText_answer\n  ...AnswerPreviewFile_answer\n  ...AnswerPreviewCheckBoxes_answer\n  ...AnswerPreviewBudgetDispatcher_answer\n  ...AnswerPreviewSortableList_answer\n  ...AnswerPreviewMatrix_answer\n  ...AnswerPreviewThemes_answer\n  ...AnswerPreviewEvents_answer\n  ...AnswerPreviewEmailWithConsents_answer\n  ...AnswerPreviewOralInterview_answer\n  ...AnswerPreviewPresentationSeparator_answer\n  ...AnswerPreviewPresentationTitle_answer\n  ...AnswerPreviewPresentationTextZone_answer\n}\n\nfragment ShallowAnswer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...AnswerString_answer\n  ...AnswerText_answer\n  ...AnswerRichText_answer\n  ...AnswerFile_answer\n  ...AnswerCheckBoxes_answer\n  ...AnswerBudgetDispatcher_answer\n  ...AnswerThemes_answer\n  ...AnswerEvents_answer\n  ...AnswerEmailWithConsents_answer\n  ...AnswerOralInterview_answer\n  ...AnswerSortableList_answer\n  ...AnswerMatrix_answer\n  ...AnswerPresentationTitle_answer\n  ...AnswerPresentationTextZone_answer\n}\n\nfragment SidebarEventCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n    }\n    id\n  }\n}\n\nfragment Sidebar_sidebar on Sidebar {\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        fullHeight\n        ...PageSectionSidebar_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SimilarAnswersSuggestions_answer on AnswerRichText {\n  ...useSimilarAnswers_answer\n}\n\nfragment SlideCaption_slide on Slide {\n  caption\n}\n\nfragment SlideContainer_slide on Slide {\n  url\n  enableOverlay\n  ...LinkSlide_slide\n}\n\nfragment SlideOverlay_slide on Slide {\n  url\n  enableOverlay\n  overlayContent\n  overlayButtonText\n  overlayContentPosition\n  overlayContentTextColor\n  overlayButtonBackgroundColor\n  overlayButtonTextColor\n  overlayBackgroundColor\n  overlayOpacity\n}\n\nfragment Slide_slide on Slide {\n  ...SlideContainer_slide\n  ...SlideCaption_slide\n  ...SlideOverlay_slide\n  image {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment SubscribeToEventButton_participativeModule on Event {\n  slug\n  authorizations {\n    contributionsSubmissionAuthorized\n  }\n  visualization {\n    __typename\n    customIntlMessages {\n      identifier\n      message\n      id\n    }\n    id\n  }\n}\n\nfragment SubscriptionModal_subscribable on ResourceWithSubscription {\n  __isResourceWithSubscription: __typename\n  id\n}\n\nfragment Subscription_subscribable on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  id\n  allowSendingNotificationOnContentUpdate\n  alreadySubscribed\n  subscribersCount\n  ...SubscriptionModal_subscribable\n}\n\nfragment TaxonomyIcons_taxonomies on ResourceTreeTaxonomy {\n  taxonomy {\n    id\n    name\n    titleImageUrl\n  }\n}\n\nfragment ThemeImage_theme on Theme {\n  name\n  images {\n    preview\n  }\n  primaryColor\n  primaryContrastColor\n}\n\nfragment TitleBarWithAction_resource on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  title\n  ancestors {\n    __typename\n    resourcePath\n    id\n  }\n  taxonomies {\n    ...TaxonomyIcons_taxonomies\n    id\n  }\n  ... on ResourceWithSubscription {\n    __isResourceWithSubscription: __typename\n    ...Subscription_subscribable\n  }\n  ...Breadcrumbs_page\n}\n\nfragment UpVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    up\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n\nfragment VideoPlayer_withVideoStream on WithBunnyStreamVideo {\n  __isWithBunnyStreamVideo: __typename\n  hlsUrl\n  hlsLibUrl\n  width\n  height\n  cover {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment VoteButton_votable on Votable {\n  __isVotable: __typename\n  remainingVotesCount\n  limitedVotesPerUser\n}\n\nfragment VoteButtons_votable on Votable {\n  __isVotable: __typename\n  authorizations {\n    __typename\n    votesSubmissionAuthorized\n    votesDownAuthorized\n    id\n  }\n  ...UpVoteButton_votable\n  ...DownVoteButton_votable\n}\n\nfragment useAnswerShouldBeConditionnallyHidden_answer on AnswerBase {\n  __isAnswerBase: __typename\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useFilterConditionnallyHiddenAnswers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useMapElementsFilteredIn_map on Map {\n  __isMap: __typename\n  id\n  filterLists {\n    filters {\n      __typename\n      id\n      ... on MapFilterTaxonomy {\n        filterElementsOutOnInitialize\n        mapTaxonomies {\n          id\n          children {\n            id\n          }\n        }\n      }\n      ... on MapFilterElement {\n        filterElementsOutOnInitialize\n        mapElements {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        mapTaxonomies {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useSidebarSectionTitle_pageSection on PageSectionWithHeadingData {\n  __isPageSectionWithHeadingData: __typename\n  title\n  iconClass\n}\n\nfragment useSimilarAnswers_answer on AnswerRichText {\n  id\n  formField {\n    __typename\n    id\n    authorizations {\n      displaySimilarContributionsSuggestions\n    }\n  }\n}\n\nfragment useVoteButtonsLabel_votable on Votable {\n  __isVotable: __typename\n  votesMode\n  currentViewerVote\n  singleVoteMode\n  ...VoteButton_votable\n}\n"
  }
};
})();

node.hash = "3d15d551047c02c9d31abc0cec02cee7";

module.exports = node;
